import React, { useEffect, useLayoutEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import pokerSocket, { ensurePokerAuthAndConnect } from '../pokerSocket';
import { usePoker } from './context/PokerContext';



import './Poker.css';
import { useSound } from '../sfx/SoundProvider';

 


// === POT PILE UTILS (для кучки фишек в банке) ===
const PILE_DENOMS = [100, 25, 5, 1];   // номиналы для визуальной кучки
const MAX_CHIPS = 12;                  // максимум видимых фишек в кучке
const MIN_PILE_AMOUNT = 0;            // до этой суммы показываем одну «условную» фишку

function makeChange(amount) {
  // жадно раскладываем сумму по номиналам (приблизительно)
  let remaining = Math.max(0, Math.round(amount));
  const chips = [];
  for (const d of PILE_DENOMS) {
    const cnt = Math.floor(remaining / d);
    for (let i = 0; i < cnt; i++) chips.push(d);
    remaining = remaining % d;
  }
  if (remaining > 0) chips.push(1);
  return chips;
}

function condense(chips, maxChips) {
  // если фишек слишком много — «склеиваем» две мелкие в одну покрупнее
  const sorted = [...chips].sort((a, b) => a - b);
  while (sorted.length > maxChips) {
    const a = sorted.shift();
    const b = sorted.shift();
    const sum = (a ?? 0) + (b ?? 0);
    const d = PILE_DENOMS.find((x) => x <= sum) ?? 1; // округляем вниз
    sorted.push(d);
    sorted.sort((x, y) => x - y);
  }
  return sorted;
}

function layout(count, baseR = 18) {
  // координаты раскладки по «цветочку» в центре банка
  const pos = [];
  if (count <= 0) return pos;
  pos.push({ x: 0, y: 0, r: 0 });
  let i = 1, ring = 1;
  while (i < count) {
    const inRing = ring === 1 ? 6 : ring * 6;
    for (let k = 0; k < inRing && i < count; k++, i++) {
      const angle = (k / inRing) * Math.PI * 2 + Math.PI / 6;
      pos.push({
        x: Math.cos(angle) * baseR * ring,
        y: Math.sin(angle) * baseR * ring * 0.6, // эллипс по вертикали
        r: Math.round(Math.sin(angle) * 10),
      });
    }
    ring++;
  }
  return pos;
}

function denomToClass(d) {
  if (d >= 100) return 'chip--100';
  if (d >= 25)  return 'chip--25';
  if (d >= 5)   return 'chip--5';
  return 'chip--1';
}


// 🔒 Пока работаем ТОЛЬКО локальным мок-движком — сокет отключаем, чтобы не мигало
const MOCK_ONLY = false;

const CHIP_SIZE = 50; // px
const DEFAULT_TURN_MS = 15000; // 15 секунд

// const API_ORIGIN = process.env.REACT_APP_API_URL; // как и в Header
const API_ORIGIN =
  process.env.REACT_APP_API_URL ||
  `${window.location.protocol}//${window.location.host}`; // запасной вариант: текущий хост


function normalizeAvatarPath(raw) {
  if (!raw) return null;
  let s = String(raw).trim().replace(/\\/g, '/');

  // data:/blob: — оставляем как есть
  if (/^(data|blob):/i.test(s)) return s;

  // //host/path → добавляем текущий протокол
  if (/^\/\//.test(s)) return `${window.location.protocol}${s}`;

  // абсолютные URL
  if (/^https?:\/\//i.test(s)) {
    // если страница https — поднимаем http→https
    if (window.location.protocol === 'https:' && /^http:\/\//i.test(s)) {
      s = s.replace(/^http:\/\//i, 'https://');
    }
    return s;
  }

  // варианты ".../uploads/..." → нормализуем к корню
  const m = s.match(/\/?uploads\/.*$/i);
  if (m) return '/' + m[0].replace(/^\/+/, '');

  // просто имя файла → считаем, что в /uploads/avatars/
  const filename = s.split('/').pop();
  return filename ? `/uploads/avatars/${filename}` : null;
}




// 👉 общий помощник для любой аватарки места
// 👉 общий помощник для любой аватарки места
function avatarUrlForSeat(seat, heroOverrideUrl, heroOverrideVer = 0, cache = {}) {
  if (!seat) return null;

  // герой — используем локальный override
  if (seat.isHero && heroOverrideUrl) return `${heroOverrideUrl}?v=${heroOverrideVer}`;

  // перебираем все возможные серверные поля
  const raw =
    seat.avatar || seat.avatarUrl || seat.avatarURL ||
    seat.photo  || seat.photoUrl  || seat.photoURL ||
    seat.avatarPath || null;

  const norm = normalizeAvatarPath(raw);

  // if (norm) {
  //   // если norm уже абсолютный — не добавляем API_ORIGIN
  //   const absolute = /^https?:\/\//i.test(norm);
  //   const base = absolute ? '' : API_ORIGIN || '';
  //   const ver = seat.avatarVer ? `?v=${seat.avatarVer}` : '';
  //   return `${base}${norm}${ver}`;
  // }
if (norm) {
  const absolute = /^https?:\/\//i.test(norm);
  const base = absolute ? '' : (API_ORIGIN || '');
  const ver  = seat.avatarVer ? `?v=${seat.avatarVer}` : '';
  let out = `${base}${norm}${ver}`;
  if (window.location.protocol === 'https:' && /^http:\/\//i.test(out)) {
    out = out.replace(/^http:\/\//i, 'https://');
  }
  return out;
}


  // кэш по нику (если сервер вообще ничего не дал)
  if (seat.username && cache[seat.username]) return cache[seat.username];

  return null;
}



// ==== CHIP UTILS & SVG ====

// === SAFE MERGE HELPERS (вставь рядом с константами) ==================
// Сравнение «score» как на сервере
function cmpScore(A, B) {
  const n = Math.max((A?.length || 0), (B?.length || 0));
  for (let i = 0; i < n; i++) {
    const a = A?.[i] ?? -1, b = B?.[i] ?? -1;
    if (a !== b) return a > b ? 1 : -1;
  }
  return 0;
}







// === MERGE SEATS: сохраняем аватарки, если дифф их не прислал ==================
function mergeSeatsKeepAvatars(prevSeats, nextSeats) {
  if (!Array.isArray(nextSeats)) return Array.isArray(prevSeats) ? prevSeats : [];

  const byIdx = new Map();
  (Array.isArray(prevSeats) ? prevSeats : []).forEach(s => {
    if (s && Number.isInteger(s.seatIndex)) byIdx.set(s.seatIndex, s);
  });

const safePrefer = (oldV, newV) => {
  const nv = (typeof newV === 'string') ? newV.trim() : newV;
  const isEmpty = nv === undefined || nv === null || nv === '' || nv === 'null' || nv === 'undefined';
  return isEmpty ? oldV : newV;
};


  const avatarFields = [
    'avatar','avatarUrl','avatarURL',
    'photo','photoUrl','photoURL',
    'avatarPath'
  ];
  const avatarVerFields = ['avatarVer','avatar_version','avatarRevision'];

  return nextSeats.map(ns => {
    if (!ns || !Number.isInteger(ns.seatIndex)) return ns;
    const ps = byIdx.get(ns.seatIndex);
    if (!ps) return ns;

    // База: обычный поверхностный мердж…
    const merged = { ...ps, ...ns };

    // …но поля аватарки НЕ перетираем пустыми значениями
    for (const f of avatarFields) {
      merged[f] = safePrefer(ps?.[f], ns?.[f]);
    }
    // Версию тоже бережём: если новую не прислали — оставляем старую
    for (const f of avatarVerFields) {
      merged[f] = (ns?.[f] === undefined || ns?.[f] === null) ? ps?.[f] : ns?.[f];
    }

    return merged;
  });
}


// Мердж публичного DIFF так, чтобы не перетирать приватку
// Мердж публичного DIFF так, чтобы не перетирать приватку и не оставлять "призрак героя"
function mergePublicDiff(prev, diff) {
  if (!diff) return prev || {};

  const { hands: _ignoredHands, heroHand: _hh, heroSeatIndex: _hsi, ...publicOnly } = diff;
  const next = { ...(prev || {}), ...publicOnly };


  if (Array.isArray(diff?.seats)) {
    next.seats = mergeSeatsKeepAvatars(prev?.seats, diff.seats);
  } else if (prev?.seats) {
    next.seats = prev.seats;
  }
  // если сервер официально открыл всех — берём публичные руки
  if (diff?.revealAll && diff?.hands) {
    next.hands = { ...(prev?.hands || {}), ...(diff.hands || {}) };
  } else if (diff?.phase === 'waiting') {
    // ключевой сброс: при waiting на столе не должно быть карманок ни у кого
    next.hands = {};
    next.winners = [];
   next.bestHands = {};
   next.details = {};
   next.revealAll = false;
  } else if (prev?.hands && !('hands' in publicOnly)) {
    next.hands = prev.hands;
  }

  if (prev?.heroSeatIndex != null && next.heroSeatIndex == null) next.heroSeatIndex = prev.heroSeatIndex;
    // моментальный визуальный фолд: проставляем флаг и убираем карты у игрока
// моментальный визуальный фолд (включая авто-фолды по таймеру)
const TIMEFOLD_TYPES = new Set([
  'fold',          // обычный фолд
  'timeout_fold',  // авто-фолд по таймеру (часто так называют)
  'auto_fold',     // авто-фолд
  'timefold',      // иногда без подчёркивания
  'forceFold'      // принудительный фолд при выходе/сидя-аут и т.п.
]);

if (TIMEFOLD_TYPES.has(diff?.lastAction?.type) && Number.isInteger(diff.lastAction.idx)) {
  const i = diff.lastAction.idx;
  next.folded = { ...(prev?.folded || {}), [i]: true };
  if (next.hands && next.hands[i]) {
    const { [i]: _drop, ...rest } = next.hands;
    next.hands = rest;
  }
}


  if (next.heroSeatIndex != null && Array.isArray(next.seats)) {
    next.seats = next.seats.map(s =>
      s?.seatIndex === next.heroSeatIndex ? { ...s, isHero: true } : { ...s, isHero: false }
    );
  }

    // ⛔ Префлоп: у мест с нулевым стеком и без ставки — не держим карманки
  if (next.phase === 'preflop' && Array.isArray(next.seats) && next.hands) {
    const pruned = { ...next.hands };
    const betsArr = Array.isArray(next.bets) ? next.bets : [];
    next.seats.forEach(seat => {
      if (!seat) return;
      const i = seat.seatIndex;
      const hasBet = Number(betsArr[i] || 0) > 0; // all-in/блайнд — оставляем
      if (Number(seat.stack) <= 0 && !hasBet) delete pruned[i];
    });
    next.hands = pruned;
  }


  return next;
}

function mergeFullSnapshot(prev, full) {
  if (!full) return prev || {};

  const merged = { ...(prev || {}), ...full };

   if (Array.isArray(full?.seats)) {
    merged.seats = mergeSeatsKeepAvatars(prev?.seats, full.seats);
  } else if (prev?.seats) {
    merged.seats = prev.seats;
  }


  const prevHands = prev?.hands || {};
  let outHands = { ...prevHands, ...(full?.hands || {}) };

  // при waiting — всегда чистые руки
  if (full?.phase === 'waiting') outHands = {};

  if (Number.isInteger(full.heroSeatIndex) && Array.isArray(full.heroHand) && full.heroHand.length === 2) {
    outHands[full.heroSeatIndex] = full.heroHand;
  }
  merged.hands = outHands;

  
    // ⛔ Префлоп: не держим карманки у нулевых стеков без ставок
  if (merged.phase === 'preflop' && Array.isArray(merged.seats) && merged.hands) {
    const pruned = { ...merged.hands };
    const betsArr = Array.isArray(merged.bets) ? merged.bets : [];
    merged.seats.forEach(seat => {
      if (!seat) return;
      const i = seat.seatIndex;
      const hasBet = Number(betsArr[i] || 0) > 0;
      if (Number(seat.stack) <= 0 && !hasBet) delete pruned[i];
    });
    merged.hands = pruned;
  }


  if (prev?.heroSeatIndex != null && merged.heroSeatIndex == null) merged.heroSeatIndex = prev.heroSeatIndex;
  if (merged.heroSeatIndex != null && Array.isArray(merged.seats)) {
    merged.seats = merged.seats.map(s =>
      s?.seatIndex === merged.heroSeatIndex ? { ...s, isHero: true } : { ...s, isHero: false }
    );
  }

  return merged;
}



// номиналы: 0.5, 1, 5, 10, 50, 100
// const CHIP_DENOMS = [100, 50, 10, 5, 1, 0.5];
// номиналы от центов до крупных
const CHIP_DENOMS = [
  100,
  50,
  10,
  5,
  1,
  0.5,
  0.25,
  0.1,
  0.05,
  0.01,
];

const toCents = (x) => Math.round((x || 0) * 100);


const POT_RING_R     = 36;  // радиус круга фишек в банке
const POT_Y_OFFSET   = -30;  // опускаем фишки чуть ниже цифры банка



// размен суммы (в $) в массив номиналов, жадным способом
function makeChipList(amount) {
  let cents = toCents(amount);
  const res = [];
  for (const d of CHIP_DENOMS) {
    const dc = toCents(d);
    const cnt = Math.floor(cents / dc);
    for (let k = 0; k < cnt; k++) res.push(d);
    cents -= cnt * dc;
  }
  return res;
}

// SVG фишки. Цвет у каждого номинала свой.
function ChipSVG({ denom, size = CHIP_SIZE }) {
  // Палитра: [цвет лица (центра), цвет обода, цвет цифры]
const palette = {
  0.01: ['#e5f0ff', '#94a3b8', '#0f172a'], // светло-голубая
  0.05: ['#dcfce7', '#16a34a', '#052e16'], // зелёная
  0.1:  ['#fef9c3', '#ca8a04', '#422006'], // жёлтая
  0.25: ['#fae8ff', '#a855f7', '#2e1065'], // фиолетовая

  0.5:  ['#f3f5f8', '#cfd6e2', '#0f172a'],
  1:    ['#ffffff', '#d9dde3', '#0f172a'],
  5:    ['#f46a6a', '#b92a2a', '#111827'],
  10:   ['#6aa7ff', '#234a97', '#ffffff'],
  50:   ['#d1b76e', '#8a6e2a', '#111827'],
  100:  ['#1a1f28', '#3b4452', '#ffffff'],
};





  const [face, ring, text] = palette[denom] || ['#ffffff', '#e5e7eb', '#111827'];
  // const label = denom % 1 === 0 ? String(denom) : denom.toFixed(1);
  const label =
  denom >= 1
    ? String(denom)
    : denom < 0.1
      ? denom.toFixed(2)
      : denom.toFixed(1);

  const uid = React.useMemo(
    () => `chip-${label}-${Math.random().toString(36).slice(2)}`,
    [label]
  );

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className="chip-svg"
      aria-label={`$${label}`}
    >
      <defs>
        {/* Фаска обода: лёгкая «металл» тень сверху/снизу */}
        <linearGradient id={`${uid}-rim`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#000" stopOpacity="0.18"/>
          <stop offset="12%"  stopColor={ring}/>
          <stop offset="88%"  stopColor={ring}/>
          <stop offset="100%" stopColor="#000" stopOpacity="0.22"/>
        </linearGradient>

        {/* Лицо с мягкой виньеткой к краям */}
        <radialGradient id={`${uid}-face`} cx="50%" cy="42%" r="65%">
          <stop offset="0%"   stopColor={face}/>
          <stop offset="100%" stopColor="#000" stopOpacity="0.08"/>
        </radialGradient>

        {/* Внутренний глянец (верхняя дуга) */}
        <linearGradient id={`${uid}-gloss`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#fff" stopOpacity="0.55"/>
          <stop offset="100%" stopColor="#fff" stopOpacity="0"/>
        </linearGradient>

        {/* Клип для глянца, чтобы не выходил за лицо */}
        <clipPath id={`${uid}-clip`}>
          <circle cx="50" cy="50" r="33" />
        </clipPath>
      </defs>

      {/* Обод с фаской */}
      <circle cx="50" cy="50" r="48" fill={`url(#${uid}-rim)`} />
      {/* Тихая внутренняя тень под фаской — придаёт толщину */}
      <circle cx="50" cy="50" r="46" fill={ring} opacity="0.08" />

      {/* Минималистичные метки на ободе (8 штук), без «дешёвой» пестроты */}
      <g fill={face} opacity=".95">
        {[0,45,90,135,180,225,270,315].map((a) => (
          <rect
            key={a}
            x="46"
            y="4"
            width="8"
            height="14"
            rx="2"
            transform={`rotate(${a} 50 50)`}
          />
        ))}
      </g>

      {/* Лицо + тонкая внутренняя окантовка для читабельности на фоне стола */}
      <circle
        cx="50"
        cy="50"
        r="33"
        fill={`url(#${uid}-face)`}
        stroke="#000"
        strokeOpacity=".15"
        strokeWidth="1.2"
      />

      {/* Верхний глянец (внутри лица) */}
      <g clipPath={`url(#${uid}-clip)`} opacity=".45">
        <ellipse cx="50" cy="36" rx="26" ry="10" fill={`url(#${uid}-gloss)`}/>
      </g>

      {/* Номинал — жирный, с лёгкой обводкой для контраста */}
      <text
        x="50" y="56"
        fontSize="28" fontWeight="900" textAnchor="middle"
        fill={text}
        style={{ paintOrder: 'stroke', stroke: '#000', strokeOpacity: .35, strokeWidth: 2 }}
      >
        {label}
      </text>
    </svg>
  );
}

 


function TableFelt() {
  // Полностью самодостаточный SVG: борт, сукно, лоток дилера и якорь #dealer-origin
  return (
    <svg
      className="table-felt"
      viewBox="0 0 1000 650"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        {/* Металлический борт */}
        <linearGradient id="railMetal" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"  stopColor="#bfc6cc"/>
          <stop offset="45%" stopColor="#8b939a"/>
          <stop offset="100%" stopColor="#5a6167"/>
        </linearGradient>
        <linearGradient id="railEdge" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stopColor="#2a2e31"/>
          <stop offset="50%"  stopColor="#3b4046"/>
          <stop offset="100%" stopColor="#2a2e31"/>
        </linearGradient>

        {/* Резиновая «проставка» перед сукном */}
        <linearGradient id="bumper" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"  stopColor="#1c2230"/>
          <stop offset="100%" stopColor="#0f1520"/>
        </linearGradient>

        {/* Красное сукно */}
        <radialGradient id="feltRed" cx="50%" cy="50%" r="80%">
          <stop offset="0%"   stopColor="#d01f29"/>   {/* центр ярче */}
          <stop offset="60%"  stopColor="#a1141b"/>
          <stop offset="100%" stopColor="#5f0c10"/>   {/* края темнее */}
        </radialGradient>

        {/* Едва заметная текстура (диагональная сетка) */}
        <pattern id="feltTexture" width="20" height="20" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
          <path d="M0 10 L20 10" stroke="#fff" strokeOpacity="0.03" strokeWidth="1"/>
          <path d="M10 0 L10 20" stroke="#fff" strokeOpacity="0.03" strokeWidth="1"/>
        </pattern>

        {/* Внутренняя тень по кромке сукна */}
        <filter id="innerShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feOffset dx="0" dy="2"/>
          <feGaussianBlur stdDeviation="5" result="b"/>
          <feComposite in="SourceGraphic" in2="b" operator="arithmetic" k2="-1" k3="1"/>
        </filter>

        {/* Лёгкий верхний глянец по сукну */}
        <linearGradient id="feltGloss" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="70%" stopColor="#ffffff" stopOpacity="0" />
        </linearGradient>

        {/* Контур овала сукна для клипа глянца и текстуры */}
        <clipPath id="feltClip">
          <rect x="95" y="75" width="810" height="500" rx="250" ry="250" />
        </clipPath>

        {/* «Золотистый» тонкий кант внутри борта */}
        <linearGradient id="goldTrim" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%"  stopColor="#f4d27a"/>
          <stop offset="45%" stopColor="#d0b05b"/>
          <stop offset="100%" stopColor="#9b7425"/>
        </linearGradient>
      </defs>

      {/* Внешний овальный борт (металл) */}
      <g>
        <rect x="12" y="12" width="976" height="626" rx="315" ry="315"
              fill="url(#railMetal)" stroke="url(#railEdge)" strokeWidth="10"/>
        {/* Узкий золотистый кант на внутренней кромке борта */}
        <rect x="30" y="30" width="940" height="590" rx="300" ry="300"
              fill="none" stroke="url(#goldTrim)" strokeWidth="3" opacity="0.9"/>
      </g>

      {/* Резиновая вставка («бампер») */}
      <rect x="60" y="60" width="880" height="530" rx="285" ry="285"
            fill="url(#bumper)" />

      {/* Сукно + текстура + глянец */}
      <g filter="url(#innerShadow)">
        {/* Овал сукна */}
        <rect x="95" y="75" width="810" height="500" rx="250" ry="250"
              fill="url(#feltRed)" />
        {/* Текстура */}
        <rect x="95" y="75" width="810" height="500" rx="250" ry="250"
              fill="url(#feltTexture)" opacity="0.35" />
        {/* Внутренняя мягкая виньетка */}
        <radialGradient id="feltVignette" cx="50%" cy="50%" r="75%">
          <stop offset="70%" stopColor="rgba(0,0,0,0)"/>
          <stop offset="100%" stopColor="rgba(0,0,0,0.18)"/>
        </radialGradient>
        <rect x="95" y="75" width="810" height="500" rx="250" ry="250"
              fill="url(#feltVignette)"/>
        {/* Верхний глянец, подрезан по форме сукна */}
        <g clipPath="url(#feltClip)" opacity="0.22">
          <rect x="95" y="75" width="810" height="160" fill="url(#feltGloss)"/>
        </g>
      </g>

      {/* Лоток дилера сверху по центру (tray) */}
      <g id="dealer-tray" transform="translate(500,60)">
        {/* Подложка, будто утоплена в борт */}
        <rect x="-70" y="-8" width="140" height="46" rx="8" ry="8"
              fill="#1b2028" stroke="#2e3542" strokeWidth="2" />
        <rect x="-64" y="-2" width="128" height="34" rx="6" ry="6"
              fill="#0c1118" stroke="#3c4656" strokeWidth="1.5" />

        {/* «Стопки фишек» условными прямоугольниками — чисто декоративно */}
        <g transform="translate(-58,2)">
          {[
            ['#7ad36b','#2b6730'],
            ['#6cb7ff','#194b85'],
            ['#ff7a7a','#8a2020'],
            ['#ffd36e','#7a5a1a'],
            ['#b78cff','#5030a0'],
          ].map((pair, i) => (
            <g key={i} transform={`translate(${i*24},0)`}>
              <linearGradient id={`chipCol${i}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={pair[0]}/>
                <stop offset="100%" stopColor={pair[1]}/>
              </linearGradient>
              <rect x="0" y="0" width="18" height="28" rx="3" ry="3"
                    fill={`url(#chipCol${i})`} stroke="rgba(255,255,255,0.15)" strokeWidth="1"/>
            </g>
          ))}
        </g>

        {/* ЯКОРЬ ДЛЯ АНИМАЦИИ РАЗДАЧИ — центр нижней кромки лотка */}
        <circle id="dealer-origin" cx="0" cy="40" r="6" fill="transparent" />
      </g>
    </svg>
  );
}




function ChipsLayer({ state, seatRefs, potRef, tableRef, winners = [], flightMs = 1200 }) {
  const [geom, setGeom] = React.useState({ pot: { x: 0, y: 0 }, seats: [] });

  // Фишки, «лежащие» в банке и не исчезающие между улицами
  // [{id, denom, x, y, status: 'in_pot'|'paying'}]
  const [potChips, setPotChips] = React.useState([]);
  const paidTurnRef = React.useRef(null); // чтобы платить 1 раз за раздачу

  // === геометрия: центр пота и «якоря» мест (чуть перед местом, в сторону пота)
  React.useLayoutEffect(() => {
    if (!tableRef.current) return;

    const measure = () => {
      const table = tableRef.current.getBoundingClientRect();
      const pot = potRef.current?.getBoundingClientRect();
      const seatsRects = (seatRefs.current || []).map(
        (el) => el?.getBoundingClientRect?.() || null
      );

      const potCenter = pot
        ? {
            x: pot.left + pot.width / 2 - table.left,
            y: pot.top + pot.height / 2 - table.top,
          }
        : { x: table.width / 2, y: table.height / 2 };

      const seatAnchors = seatsRects.map((r) => {
        if (!r)
          return { x: 0, y: 0, ux: 1, uy: 0, px: 0, py: 1 };

        const cx = r.left + r.width / 2 - table.left;
        const cy = r.top + r.height / 2 - table.top;

        const vx = potCenter.x - cx;
        const vy = potCenter.y - cy;
        const len = Math.hypot(vx, vy) || 1;
        const ux = vx / len;
        const uy = vy / len;
        const px = -uy;
        const py = ux;

        const seatRadius = Math.max(r.width, r.height) / 2;
        const minClearFromSeat = seatRadius + CHIP_SIZE * 0.7;
        const minGapToPot = 500;
        const toward = Math.min(len * 0.62, Math.max(0, len - minGapToPot));
        const distOut = Math.max(minClearFromSeat, toward);
        const EXTRA_PUSH = 80;

        const ax = cx + ux * (distOut + EXTRA_PUSH);
        const ay = cy + uy * (distOut + EXTRA_PUSH);
        return { x: ax, y: ay, ux, uy, px, py };
      });

      setGeom({ pot: potCenter, seats: seatAnchors });
    };

    measure();
    const raf = requestAnimationFrame(measure);
    window.addEventListener('resize', measure);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', measure);
    };
  }, [
    state?.__turnId,
    state?.phase,
    state?.__revealPending,
    state?.__collecting,
    state?.__runoutPending,
    state?.seatsMax,
  ]);

  // Компактная «раскладка» точек в центре пота
const potSlot = React.useCallback(
  (idx, totalOverride) => {
    // считаем позиции по «цветочку»; totalOverride нужен во время добавления
    const total = Math.max(1, totalOverride ?? potChips.length);
    const ring  = layout(total, POT_RING_R);
    const p     = ring[idx] || { x: 0, y: 0 };
    return {
      x: geom.pot.x + p.x,
      y: geom.pot.y + POT_Y_OFFSET + p.y, // опускаем чуть ниже пузырька
    };
  },
  [geom.pot.x, geom.pot.y, potChips.length]
);




 
  // Если окно перетащили/ресайзнули — подвинем «лежачие» фишки к центру пота
  React.useEffect(() => {
    if (!potChips.length) return;
    setPotChips((prev) =>
      prev.map((ch, i) =>
        ch.status === 'in_pot' ? { ...ch, ...potSlot(i) } : ch
      )
    );
  }, [geom.pot.x, geom.pot.y]); // eslint-disable-line

  const collecting = !!(
    state?.__collecting || state?.__revealPending || state?.__runoutPending
  );

  // Когда сервер собирает ставки — анимируем ЧЕРЕЗ ПОТ и оставляем там
  React.useEffect(() => {
    if (!collecting) return;

    const bets = state?.bets || [];
    const adds = [];

    bets.forEach((amount, i) => {
      if (!amount || amount <= 0) return;

      const anchor =
        geom.seats[i] || { x: 0, y: 0, ux: 1, uy: 0, px: 0, py: 1 };
      const list = makeChipList(amount); // массив номиналов: [100,10,10,...]

      list.forEach((denom, k) => {
        const lateral = (k - (list.length - 1) / 2) * (CHIP_SIZE * 0.55);
        const depth = Math.floor(k / 5) * (CHIP_SIZE * 0.25);

        const from = {
          x: anchor.x + anchor.px * lateral + anchor.ux * depth,
          y: anchor.y + anchor.py * lateral + anchor.uy * depth,
        };

        const id = `pot-${state?.__turnId}-${i}-${k}-${Math.random()
          .toString(36)
          .slice(2)}`;
       const toIdx = potChips.length + adds.length;
const to    = potSlot(toIdx, potChips.length + adds.length); // ← передаём общее количество


        adds.push({
          id,
          denom,
          x: from.x,
          y: from.y,
          targetX: to.x,
          targetY: to.y,
          status: 'in_pot', // после одного кадра твёрдо «лежит» в поте
        });
      });
    });

    if (!adds.length) return;

    // Добавили в DOM у стартовых координат…
    setPotChips((prev) => [...prev, ...adds]);

    // …и в следующий кадр переложили в центр пота — CSS доплывёт
    requestAnimationFrame(() => {
      setPotChips((prev) =>
        prev.map((ch) => {
          const add = adds.find((a) => a.id === ch.id);
          return add ? { ...ch, x: add.targetX, y: add.targetY } : ch;
        })
      );
    });
    // eslint-disable-next-line
  }, [collecting]);

  // Раздача закончилась — есть победитель(и): анимируем выплату с пота к месту(-ам)
  React.useEffect(() => {
    const turnId = state?.__turnId;

    const canPay =
      state?.phase === 'showdown' &&
      Array.isArray(winners) &&
      winners.length > 0 &&
      potChips.length > 0 &&
      paidTurnRef.current !== turnId &&
      !state?.__collecting &&
      !state?.__revealPending &&
      !state?.__runoutPending;

    if (!canPay) return;

    // распределим фишки «по кругу» между победителями (деление пополам/на троих и т.п.)
    setPotChips((prev) =>
      prev.map((ch, idx) => {
        const w = winners[idx % winners.length];
        const anchor =
          geom.seats[w] || { x: geom.pot.x, y: geom.pot.y, ux: 1, uy: 0, px: 0, py: 1 };

        const spread = (idx % 8 - 3.5) * (CHIP_SIZE * 0.45);
        const to = {
          x: anchor.x - anchor.ux * 30 + anchor.px * spread,
          y: anchor.y - anchor.uy * 30 + anchor.py * spread,
        };

        return { ...ch, x: to.x, y: to.y, status: 'paying' };
      })
    );

    const T = 750; // должна быть чуть длиннее твоего CSS transition (0.65s)
    const t = setTimeout(() => {
      setPotChips([]); // банк пуст (выплата завершена)
      paidTurnRef.current = turnId;
    }, T);

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [state?.phase, winners?.length, potChips.length]);

  // Новая раздача/ожидание — очищаем локальную «память» банка и флаг выплаты
  React.useEffect(() => {
    if (state?.phase === 'waiting') {
      setPotChips([]);
      paidTurnRef.current = null;
    }
  }, [state?.phase, state?.__turnId]);

  // 👉 Отрисовка
  const chipsDom = [];

  // 1) Фишки, которые уже «лежат» в центре банка (persist)
  potChips.forEach((ch, i) => {
    chipsDom.push(
      <div
        key={ch.id}
        className="chip--anim"
        style={{
          width: `${CHIP_SIZE}px`,
          height: `${CHIP_SIZE}px`,
          transform: `translate(${ch.x - CHIP_SIZE / 2}px, ${ch.y - CHIP_SIZE / 2}px)`,
          zIndex: 200 + i,
          pointerEvents: 'none',
        }}
      >
        <ChipSVG denom={ch.denom} />
      </div>
    );
  });

  // 2) Для наглядности — пока «сбор» не начался, показываем текущие ставки рядом с местом
  if (!collecting) {
    const bets = state?.bets || [];
    bets.forEach((amount, i) => {
      if (!amount || amount <= 0) return;
      const anchor =
        geom.seats[i] || { x: 0, y: 0, ux: 1, uy: 0, px: 0, py: 1 };
      const list = makeChipList(amount);
      list.forEach((denom, k) => {
        const lateral = (k - (list.length - 1) / 2) * (CHIP_SIZE * 0.55);
        const depth = Math.floor(k / 5) * (CHIP_SIZE * 0.25);
        const from = {
          x: anchor.x + anchor.px * lateral + anchor.ux * depth,
          y: anchor.y + anchor.py * lateral + anchor.uy * depth,
        };

        chipsDom.push(
          <div
            key={`live-${i}-${k}-${denom}`}
            className="chip--anim"
            style={{
              width: `${CHIP_SIZE}px`,
              height: `${CHIP_SIZE}px`,
              transform: `translate(${from.x - CHIP_SIZE / 2}px, ${from.y - CHIP_SIZE / 2}px)`,
              zIndex: 100 + k,
              pointerEvents: 'none',
            }}
          >
            <ChipSVG denom={denom} />
          </div>
        );
      });
    });
  }

  return <div className="chips-layer">{chipsDom}</div>;
}




const Card = React.memo(function Card({ code, big }) {
  if (!code) return null;
  const rank = code[0];
  const suit = code[1];
  const showRank = rank === 'T' ? '10' : rank; // ⬅️ тут меняем отображение десятки
  const red = (suit === '♥' || suit === '♦');
  return (
    <div className={`p-card ${big ? 'p-card--big' : ''} ${red ? 'is-red' : ''}`}>
      <div className="p-card__corner">{showRank}{suit}</div>
      <div className="p-card__center">{showRank}{suit}</div>
    </div>
  );
}, (prev, next) => prev.code === next.code && prev.big === next.big);
 

function BetPanel({
  open,
  onClose,
  onConfirm,
  allowed = {},
  pot = 0,
  currentMyBet = 0,
  raiseMode = false,
  tick = 0.01
}) {
  // Округление к сетке с шагом tick, привязанной к min:
  // допустимые числа: min, min + tick, min + 2*tick, ...
  const roundToStep = (x, base, step) => {
    if (!Number.isFinite(x)) return base;
    const n = Math.round((x - base) / step);
    const v = base + n * step;
    return Math.round(v * 100) / 100; // до центов
  };




  // const min = Math.max(0, (raiseMode ? allowed.minRaiseTo : allowed.minBet) ?? 0);
  // const max = Math.max(min, allowed.maxRaiseTo ?? min);
  // const clamp = (v) => Math.min(Math.max(v, min), max);
  // const initialTo = clamp(
  //   roundToStep(raiseMode ? (allowed.minRaiseTo ?? min) : (allowed.minBet ?? min), min, tick)
  // );

  // const [toAmount, setToAmount] = useState(initialTo);
  // if (!open) return null;


    const min = Math.max(0, (raiseMode ? allowed.minRaiseTo : allowed.minBet) ?? 0);
  const max = Math.max(min, allowed.maxRaiseTo ?? min);

  // если сервер сказал "min == max" или max == 0 — рейз невозможен, панель даже не показываем
  const raiseLocked = !(max > 0 && max > min);

  const clamp = (v) => Math.min(Math.max(v, min), max);
  const initialTo = clamp(
    roundToStep(raiseMode ? (allowed.minRaiseTo ?? min) : (allowed.minBet ?? min), min, tick)
  );

  const [toAmount, setToAmount] = useState(initialTo);

  if (!open || raiseLocked) return null;



  const setFraction = (f) => {
    const raw = min + (max - min) * f;
    setToAmount(clamp(roundToStep(raw, min, tick)));
  };
  const toAllIn = () => setToAmount(clamp(roundToStep(max, min, tick)));

  return (
    <div className="bet-panel">
      <div className="bet-panel__title">
        {raiseMode ? 'Raise to' : 'Bet'}
      </div>

      <div className="bet-panel__slider">
        <input
          type="range"
          min={min}
          max={max}
          step={tick} // шаг = SB
          value={toAmount}
          onChange={(e) =>
            setToAmount(clamp(roundToStep(Number(e.target.value), min, tick)))
          }
        />
      </div>

      <div className="bet-panel__row">
        <div className="bet-panel__quick">
          <button onClick={() => setFraction(0.50)}>½ pot</button>
          <button onClick={() => setFraction(2/3)}>⅔ pot</button>
          <button onClick={() => setFraction(1)}>Pot</button>
          <button onClick={toAllIn}>All-in</button>
        </div>
        <div className="bet-panel__num">
          <span>to: </span>
          <input
            type="number"
            value={toAmount}
            min={min}
            max={max}
            step={tick} // шаг = SB
            onChange={(e) =>
              setToAmount(clamp(roundToStep(Number(e.target.value), min, tick)))
            }
          />
          <span className="bet-panel__hint">min {min}, max {max}</span>
        </div>
      </div>

      <div className="bet-panel__actions">
        <button className="p-btn p-btn--ghost" onClick={onClose}>Cancel</button>
       <button
        className="p-btn p-btn--gold"
        onClick={() => onConfirm(toAmount)}
        disabled={toAmount < min || toAmount > max}
      >
        {raiseMode ? 'Raise' : 'Bet'}
      </button>

      </div>
    </div>
  );
}


function PotPile({ amount = 0, small = false }) {

  const chips = useMemo(() => {
    const list = makeChange(amount);
    return condense(list, MAX_CHIPS);
  }, [amount]);

if (small || amount < MIN_PILE_AMOUNT) {
  return (
    <div className="pot-pile pot-pile--single">
      {/* декоративная «пустая» фишка без цифры */}
      <div className="chip chip--anim chip--1" aria-hidden="true" />
    </div>
  );
}


  const pos = layout(chips.length);

  return (
    <div className="pot-pile">
     {chips.map((d, i) => {
  const p = pos[i] || { x: 0, y: 0, r: 0 };
  return (
    <div
      key={i}
      className={`chip chip--anim ${denomToClass(d)}`}
      style={{
        transform: `translate(${p.x}px, ${p.y}px) rotate(${p.r}deg)`,
        zIndex: 100 + i,
      }}
      data-denom={d}
      aria-hidden="true"   // важное: это чисто декоративные фишки
    />
  );
})}

    </div>
  );
}

export default function PokerTable({ userAvatar }) {
  const { tableId: tableIdParam } = useParams();
  const tableId = Number(tableIdParam);
  const [avatarCache, setAvatarCache] = useState({});
  const [quickAmount, setQuickAmount] = useState(0);

  
  // ВНУТРИ PokerTable, рядом с другими useState:
const [heroAvatarUrl, setHeroAvatarUrl] = useState(null);
const [heroAvatarVer, setHeroAvatarVer] = useState(0);
const [imgError, setImgError] = useState({}); // { [url]: true }



const { play } = useSound();
const lastPlayedCallRef = useRef(null); // защита от повторов
const lastPlayedFoldRef = useRef(null);
const skipNextHeroFoldRef = useRef(false);
 // запомним предыдущий объект lastAction, чтобы не реагировать на одни и те же данные
 const prevFoldLaObjRef = useRef(null);
// 🔊 Для фильтра "реально списались фишки?"
const prevStacksRef = useRef({});

const lastPlayedAllInRef = useRef(null); // 🔒 антидубль для оллина
const skipNextBetEchoRef = useRef(false);

// 🔊 антидубль для звука открытия борда
const lastBoardLenRef = useRef(0);         // предыдущая длина board (0,3,4,5)
const lastBoardSigRef = useRef(null);      // сигнатура для защиты от повторов
const seenTurnIdRef   = useRef(null);      // чтобы не играть звук при первом появлении борда в новой раздаче
const skipNextCheckEchoRef = useRef(false);
const lastPhaseRef = useRef('waiting');

// --- ⏱️ СТЕЙТЫ ТАЙМЕРА ХОДА ---
const [turnMsLeft, setTurnMsLeft]   = useState(0);                 // сколько остаётся (мс)
const [turnTotalMs, setTurnTotalMs] = useState(DEFAULT_TURN_MS);   // всего времени на ход (мс)
const turnTimerRef = useRef(null);                                  // setInterval хендл













// --- СТАТУС СЕТИ / СОКЕТА ---
const [netMsg, setNetMsg] = useState('');     // текст баннера
const lastEvtRef   = useRef(Date.now());      // когда пришло ЛЮБОЕ событие от сервера
const lostSinceRef = useRef(null);            // когда потеряли соединение (для обратного отсчёта)
// const STALE_MS = 120000;                        // «подвисло» если 8+ сек нет событий
const KICK_MS  = 60000;                       // у тебя минута на «авто-фолд»/кик — счётчик





  const [q] = useSearchParams();
  const spectator = q.get('spectator') === '1';
  const leavingRef = useRef(false);
  const navigate = useNavigate();
  const { tableState, setTableState } = usePoker();
  const username = localStorage.getItem('username') || 'a';

  const lastNudgeRef = useRef(null);
// 👇 ДОБАВЬ
const gotHeroRef = useRef(spectator); // зритель — не ждём приватку
const requestedPostBBRef = useRef(false);

const tableRef = useRef(null);      // общий холст
const potRef   = useRef(null);      // блок банка в центре

const CHIP_FLIGHT_MS = 1200; // <-- 1200ms = медленнее. Хочешь ещё медленнее — 1500/1800.

const [flyingChips, setFlyingChips] = useState([]); // [{id,x,y,dx,dy,ttl}]
const gotSnapshotRef = useRef(false);
 
const seatRefs = useRef([]); // массив DOM-элементов
const [tempReveals, setTempReveals] = useState({}); 
// { [seatIndex]: { cards: ['Ah','Kd'] } }
const tempRevealTimersRef = useRef({});
const [dockPos, setDockPos] = useState({ left: 0, top: 0 });
const [dockPlacement, setDockPlacement] = useState('bottom'); // 'top' | 'bottom' | 'left' | 'right'  

const dealSoundTimerRef = useRef(null);
// Округление к сетке с шагом tick, привязанной к min:
// допустимые числа: min, min + tick, min + 2*tick, ...
const roundToStep = (x, base, step) => {
  if (!Number.isFinite(x)) return base;
  const n = Math.round((x - base) / step);
  const v = base + n * step;
  // до центов
  return Math.round(v * 100) / 100;
};





// ── помощники показа баннера сети ─────────────────────────────────────────
const netHideTimerRef = useRef(null);

// Постоянный баннер (не гасим сам)
const showNet = useCallback((text) => {
  if (netHideTimerRef.current) {
    clearTimeout(netHideTimerRef.current);
    netHideTimerRef.current = null;
  }
  setNetMsg(text);
}, []);

// Короткая «плашка» (авто-скрытие через ms)
const flashNet = useCallback((text, ms = 2500) => {
  if (netHideTimerRef.current) clearTimeout(netHideTimerRef.current);
  setNetMsg(text);
  netHideTimerRef.current = setTimeout(() => setNetMsg(''), ms);
}, []);

// Чистим таймер при размонтировании
useEffect(() => {
  return () => {
    if (netHideTimerRef.current) clearTimeout(netHideTimerRef.current);
  };
}, []);



// === Ре-join комнаты + принудительный снапшот ===
const rejoinRoomAndSnapshot = useCallback(() => {
  try {
    ensurePokerAuthAndConnect();
    pokerSocket.emit('table:watch', { tableId }, () => {
      pokerSocket.emit('table:requestSnapshot', { tableId }, (full) => {
        if (!full || full.id !== tableId) return;

        setTableState((prev) => mergeFullSnapshot(prev, full));

        gotSnapshotRef.current = true;
        if (Number.isInteger(full?.heroSeatIndex)) {
          gotHeroRef.current = true;
        }
        console.log('[CL] (re)joined & snapshot ok', { id: full.id, hero: full.heroSeatIndex });
      });
    });
  } catch (e) {
    console.warn('[CL] rejoinRoomAndSnapshot failed', e);
  }
}, [tableId, setTableState]);

// === Жёсткий реконнект сокета + ре-join ===
const hardReconnect = useCallback(() => {
  try {
    ensurePokerAuthAndConnect();
    const mgr = pokerSocket.io;
    if (mgr?.connected === false) mgr.open();
    if (!pokerSocket.connected) pokerSocket.connect();
  } catch {}
  try { rejoinRoomAndSnapshot(); } catch {}
}, [rejoinRoomAndSnapshot]);

// утилита проверки, существует ли картинка
function testImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = url;
  });
}


const heroSeatIndex = useMemo(() => {
  const arr = tableState?.seats || [];
  const i = arr.findIndex(s => s?.isHero);
  return i >= 0 ? i : -1;
}, [tableState?.seats]);


function revealTempLocal(seatIndex, cards, ms = 3000) {
  if (!Array.isArray(cards) || cards.length !== 2) return;
  // записываем карты
  setTempReveals(prev => ({ ...prev, [seatIndex]: { cards } }));
  // перезапускаем таймер снятия
  if (tempRevealTimersRef.current[seatIndex]) {
    clearTimeout(tempRevealTimersRef.current[seatIndex]);
  }
  tempRevealTimersRef.current[seatIndex] = setTimeout(() => {
    setTempReveals(prev => {
      const { [seatIndex]: _drop, ...rest } = prev;
      return rest;
    });
    tempRevealTimersRef.current[seatIndex] = null;
  }, Number(ms) || 3000);
}

// === SOCKET ACTIONS ===
function mapErr(code) {
  switch (code) {
    case 'NOT_STARTED':     return 'Раздача ещё не началась.';
    case 'NOT_SEATED':      return 'Вы не сидите за столом.';
    case 'NOT_YOUR_TURN':   return 'Сейчас не ваш ход.';
    case 'DEALING':         return 'Идёт сдача/раскрытие карт.';
    case 'BAD_ACTION':      return 'Неверное действие.';
    default:                return code || 'Неизвестная ошибка.';
  }
}

function sendAction(type, to) {
  const st = tableState;
  if (!st?.id) return;
  ensurePokerAuthAndConnect();
  pokerSocket.emit('table:action', { tableId: st.id, type, to }, (res) => {
    if (!res?.ok) alert(mapErr(res?.error));
  });
}


function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

function updateDockPosition() {
  const hi = heroSeatIndex;
  const t = tableRef.current;
  const seatEl = seatRefs.current?.[hi];
  if (!t || !seatEl || hi < 0) return;

  const tr = t.getBoundingClientRect();
  const sr = seatEl.getBoundingClientRect();

  // центр места относительно контейнера стола
  const cx = sr.left + sr.width / 2 - tr.left;
  const cy = sr.top  + sr.height/ 2 - tr.top;

  // Выберем, куда «выносить» панель, чтобы не перекрывать карты:
  // верхняя треть — панель СНИЗУ, нижняя треть — панель СВЕРХУ,
  // середина — влево/вправо по положению относительно центра стола.
  let placement = 'bottom';
  const h = tr.height, w = tr.width;
  if (cy < h * 0.33) placement = 'top';
  else if (cy > h * 0.67) placement = 'bottom';
  else placement = (cx < w * 0.5) ? 'right' : 'left';

  // Смещения относительно центра места
  const offX = sr.width * 1.2;
  const offY = sr.height * 1.2;
  let dx = 0, dy = 0;
  if (placement === 'top')    dy =  +offY;      // место сверху → панель ниже места
  if (placement === 'bottom') dy =  -offY;      // место снизу → панель выше места
  if (placement === 'left')   dx =  -offX;      // место справа → панель слева от места
  if (placement === 'right')  dx =  +offX;      // место слева → панель справа от места

  const left = clamp(cx + dx, 16, w - 16);
  const top  = clamp(cy + dy, 16, h - 16);

  setDockPlacement(placement);
  setDockPos({ left, top });
}

// Обновляем при любых факторах: чей ход, ресайз, перерисовка стола/мест.
useLayoutEffect(() => { updateDockPosition(); }, [
  heroSeatIndex,
  tableState?.toActIndex,
  tableState?.__turnId,
  tableState?.seats?.length
]);


useEffect(() => {
  const onResize = () => updateDockPosition();
  window.addEventListener('resize', onResize);
  const ro = (window.ResizeObserver)
    ? new ResizeObserver(onResize)
    : null;
  if (ro && tableRef.current) ro.observe(tableRef.current);
  return () => {
    window.removeEventListener('resize', onResize);
    if (ro && tableRef.current) ro.unobserve(tableRef.current);
  };
}, []);




// защита от повторов уже есть выше:
// const lastPlayedCallRef = useRef(null);
useEffect(() => {
  const la = tableState?.lastAction;
  if (!la) return;

  // 🚫 во время дилерских шагов звук не играем
  if (tableState?.__collecting || tableState?.__revealPending || tableState?.__runoutPending) return;

  const t = String(la.type || '').toLowerCase();
  if (t !== 'call') return;

  const idx = Number(la.idx);
  const put = Number(la.put || 0);
  if (!(put > 0)) return;

  // если это по сути оллин — отдаём на другой эффект (allin) и не играем koll
  const EXPLICIT_ALLIN = new Set(['allin', 'all-in', 'all_in', 'all in']);
  const seatNow   = tableState?.seats?.[idx];
  const stackNow  = Number(seatNow?.stack ?? NaN);
  const isPost    = t.startsWith('post') || t.includes('ante') || t.includes('bring');
  const isAllInByStack = (put > 0) && Number.isFinite(stackNow) && stackNow <= 0 && !isPost;
  if (EXPLICIT_ALLIN.has(t) || isAllInByStack) return;

  // реально ли списались фишки со стека?
  const currStack = Number(tableState?.seats?.[idx]?.stack ?? NaN);
  const prevStack = Number(prevStacksRef.current[idx] ?? NaN);
  const spent = (Number.isFinite(prevStack) && Number.isFinite(currStack)) ? (prevStack - currStack) : 0;

  // BB-check в лимп-банке: bet уже равен currentBet, со стека не списываем
  const isBBCheck =
    tableState?.phase === 'preflop' &&
    idx === tableState?.bbIndex &&
    Math.abs((tableState?.bets?.[idx] || 0) - (tableState?.currentBet || 0)) < 1e-6;

  if (spent <= 0.005 || isBBCheck) return; // ✋ не играем звук

  // антидубль
  const sig = `${tableState?.__turnId || 0}:${idx}:call:${put}`;
  if (lastPlayedCallRef.current === sig) return;
  lastPlayedCallRef.current = sig;

  try { play('koll'); } catch (e) { console.warn('SFX koll failed', e); }
}, [
  play,
  tableState?.lastAction,
  tableState?.__collecting,
  tableState?.__revealPending,
  tableState?.__runoutPending,
  tableState?.__turnId
]);





// Держим «прошлые» стеки игроков для детекта реального списания фишек
useEffect(() => {
  const map = {};
  (tableState?.seats || []).forEach(s => {
    if (!s) return;
    map[s.seatIndex] = Number(s.stack || 0);
  });
  prevStacksRef.current = map;
}, [tableState?.seats, tableState?.__turnId]);



// 🔊 ЭФФЕКТ ЗВУКА ОЛЛИНА
useEffect(() => {
  const la = tableState?.lastAction;
  if (!la) return;

  // 🚫 во время дилерских шагов звук не играем
  if (tableState?.__collecting || tableState?.__revealPending || tableState?.__runoutPending) return;

  const t = String(la.type || '').toLowerCase();
  const idx = Number(la.idx);
  const put = Number(la.put || 0);

  // 1) Явные типы "оллина" от сервера
  const EXPLICIT_ALLIN = new Set(['allin', 'all-in', 'all_in', 'all in']);
  const isExplicitAllIn = EXPLICIT_ALLIN.has(t);

  // 2) Эвристика: после действия стек игрока стал 0 (и это не пост блайнда/анте/бринг-ин)
  const seatNow = tableState?.seats?.[idx];
  const stackNow = Number(seatNow?.stack ?? NaN);
  const isPostType = t.startsWith('post') || t.includes('ante') || t.includes('bring');
  const isAllInByStack = (put > 0) && Number.isFinite(stackNow) && stackNow <= 0 && !isPostType;

  // если это не оллин — выходим
  if (!(isExplicitAllIn || isAllInByStack)) return;

  // антидубль в рамках одной раздачи
  const sig = `${tableState?.__turnId || 0}:${idx}:allin:${put}`;
  if (lastPlayedAllInRef.current === sig) return;
  lastPlayedAllInRef.current = sig;

  try {
    // основной звук оллина
    play('allin');
  } catch (e) {
    // если такого ключа нет — подстрахуемся более общим звуком
    try { play('raise'); } catch {}
  }
}, [
  play,
  tableState?.lastAction,
  tableState?.__collecting,
  tableState?.__revealPending,
  tableState?.__runoutPending,
  tableState?.__turnId,
  tableState?.seats // важно: чтобы переоценить момент, когда стек стал 0
]);





// инициализация и синк с пропсом/LS
useEffect(() => {
  // приоритет: проп → LS
  const raw = userAvatar || localStorage.getItem('avatar') || null;
 const norm = normalizeAvatarPath(raw);
const finalUrl = !norm
  ? null
  : (/^https?:\/\//i.test(norm) ? norm : `${API_ORIGIN || ''}${norm}`);
setHeroAvatarUrl(finalUrl);
setHeroAvatarVer(v => v + 1);

}, [userAvatar]);

// реагируем на глобальное событие смены аватарки
useEffect(() => {
  const onAvatarUpdated = (e) => {
    const next = e?.detail?.avatar || localStorage.getItem('avatar') || null;
    const norm = normalizeAvatarPath(next);
    const finalUrl = !norm
      ? null
      : (/^https?:\/\//i.test(norm) ? norm : `${API_ORIGIN || ''}${norm}`);
    setHeroAvatarUrl(finalUrl);
    setHeroAvatarVer(v => v + 1); // форс-обновление <img> по ?v=
  };
  window.addEventListener('avatar-updated', onAvatarUpdated);
  return () => window.removeEventListener('avatar-updated', onAvatarUpdated);
}, []);


// обновляем "вчерашние" стеки после всех эффектов, чтобы на следующем тике было с чем сравнить
useEffect(() => {
  const map = {};
  (tableState?.seats || []).forEach(s => { if (s) map[s.seatIndex] = Number(s.stack || 0); });
  prevStacksRef.current = map;
}, [tableState?.seats, tableState?.__turnId]);


const safeLeaveTable = useCallback((tid, { navigateAfter = false } = {}) => {
  if (leavingRef.current) return;        // защита от двойного клика/двойного вызова
  leavingRef.current = true;

  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;

    try { pokerSocket.emit('table:leave', { tableId: tid }); } catch {}
    if (navigateAfter) {
      try { navigate('/poker', { replace: true }); } catch {}
    }

    // снимаем блокировку на следующий кадр
    setTimeout(() => { leavingRef.current = false; }, 0);
  };

  // Фолбэк: если ack потеряется — всё равно уйдём через 1.2с
  const FALLBACK_MS = 1200;
  const timer = setTimeout(finish, FALLBACK_MS);

  try {
    pokerSocket.emit('table:leaveSeat', { tableId: tid, forceFold: true }, () => {
      clearTimeout(timer);
      finish();
    });
  } catch {
    clearTimeout(timer);
    finish();
  }
}, [navigate]);


// подсунем свою аву в локальный кэш и в localStorage — другие вкладки подхватят
useEffect(() => {
  if (username && heroAvatarUrl) {
    const hint = `${heroAvatarUrl}?v=${heroAvatarVer}`;
    setAvatarCache(prev => ({ ...prev, [username]: hint }));
    try { localStorage.setItem(`__poker_avatar_hint__${username}`, hint); } catch {}
  }
}, [username, heroAvatarUrl, heroAvatarVer]);

// слушаем подсказки из других вкладок
useEffect(() => {
  const onStorage = (e) => {
    if (e.key?.startsWith('__poker_avatar_hint__') && e.newValue) {
      const uname = e.key.replace('__poker_avatar_hint__', '');
      setAvatarCache(prev => ({ ...prev, [uname]: e.newValue }));
    }
  };
  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
}, []);



useEffect(() => {
  const onRevealTemp = (payload) => {
    if (!payload || payload.tableId !== tableId) return;
    const { seatIndex, cards, ms } = payload;
    revealTempLocal(Number(seatIndex), cards, Number(ms) || 3000);
  };
  pokerSocket.on('table:revealTemp', onRevealTemp);
  return () => {
    pokerSocket.off('table:revealTemp', onRevealTemp);
    // подчистим таймеры при уходе со стола
    Object.values(tempRevealTimersRef.current || {}).forEach(t => t && clearTimeout(t));
    tempRevealTimersRef.current = {};
  };
}, [tableId]);

// ❇️ Сброс временных показов при старте новой раздачи
useEffect(() => {
  setTempReveals({});
  Object.values(tempRevealTimersRef.current || {}).forEach(t => t && clearTimeout(t));
  tempRevealTimersRef.current = {};
}, [tableState?.__turnId]);


useEffect(() => {
  if (MOCK_ONLY) return;
  if (!Number.isFinite(tableId)) {
    navigate('/poker', { replace: true });
    return;
  }
  ensurePokerAuthAndConnect();

  // --- PUBLIC DIFF ---
  const onUpdate = (diff) => {
  // if (!gotSnapshotRef.current) {
  //   if (!diff || (diff.seatsMax === undefined && diff.id === undefined)) return;
  // }
// до первого снапшота пропускаем только «самодостаточные» апдейты:
// (a) есть id или seatsMax, ИЛИ (b) есть seats (прилетела чистая посадка)
if (!gotSnapshotRef.current) {
  const hasIdentity = diff && (diff.id !== undefined || diff.seatsMax !== undefined);
  const hasSeats    = diff && Array.isArray(diff.seats);
  if (!hasIdentity && !hasSeats) return;
}

  setTableState((prev) => {
    // 👉 Предохранитель: пока не знаем героя (и мы не зритель) — не затираем state публичкой
    // if (!gotHeroRef.current && !spectator) {
    //   console.debug('[CL] update: skipped until hero is ready', { turn: diff?.__turnId });
    //   return prev || {};
    // }
// 👉 Если герой ещё не известен, пропускаем ТОЛЬКО несущественные диффы.
// Дифф, который явно меняет seats или переводит стол в 'waiting', пропускать НЕЛЬЗЯ.
if (!gotHeroRef.current && !spectator) {
  const touchesSeatsOrReset =
    Array.isArray(diff?.seats) || diff?.phase === 'waiting';
  if (!touchesSeatsOrReset) {
    console.debug('[CL] update: skipped until hero is ready', { turn: diff?.__turnId });
    return prev || {};
  }
}

    const next = mergePublicDiff(prev, diff);

    // 👉 Фоллбэк: если героя всё ещё нет, но знаем username — восстановим индекс по seats
    if (next.heroSeatIndex == null && Array.isArray(next.seats)) {
      try {
        const uname = localStorage.getItem('username');
        if (uname) {
          const me = next.seats.find(s => s?.username === uname);
          if (me) {
            next.heroSeatIndex = me.seatIndex;
            // перетопим isHero
            next.seats = next.seats.map(s => s?.seatIndex === me.seatIndex ? { ...s, isHero: true } : { ...s, isHero: false });
            console.debug('[CL] hero: recovered by username', { hero: me.seatIndex, uname });
            gotHeroRef.current = true;
          }
        }
      } catch {}
    }

    console.log('[CL] update', { id: next?.id, seatsMax: next?.seatsMax, hero: next?.heroSeatIndex });
    return next;
  });
};


  // --- PRIVATE (только моё место/карманки) ---
  const onPrivate = (payload) => {
    if (!payload || payload.tableId !== tableId) return;
    const { heroSeatIndex, heroHand } = payload;
    if (!Number.isInteger(heroSeatIndex)) return;

    setTableState((prev) => {
      const next = { ...(prev || {}) };
         next.heroSeatIndex = heroSeatIndex;

      // Не считаем "нулевым", пока seats не пришли; all-in с нулём оставляем (есть ставка)
      const seatNow  = (next.seats || []).find(s => s?.seatIndex === heroSeatIndex) || null;
      const brokeNow = seatNow ? Number(seatNow.stack || 0) <= 0 : false;
      const phaseNow = next.phase;
      const hasBetNow = Number((next.bets || [])[heroSeatIndex] || 0) > 0;

      // Приватка героя: на префлопе с нулевым стеком БЕЗ ставки — не принимаем
      if (!(phaseNow === 'preflop' && brokeNow && !hasBetNow) && Array.isArray(heroHand) && heroHand.length === 2) {
        next.hands = { ...(next.hands || {}), [heroSeatIndex]: heroHand };
      } else {
        next.hands = { ...(next.hands || {}) };
      }


      if (Array.isArray(next.seats)) {
        next.seats = next.seats.map(s =>
          s?.seatIndex === heroSeatIndex ? { ...s, isHero: true } : { ...s, isHero: false }
        );
      }
      console.log('[CL] private', { hero: heroSeatIndex, hasHand: Array.isArray(heroHand) });
      return next;
    });
     gotHeroRef.current = true;
     console.log('[CL] hero: ready-by-private', { hero: heroSeatIndex });
  };

  pokerSocket.on('table:update', onUpdate);
  pokerSocket.on('table:private', onPrivate);




  // --- FULL SNAPSHOT PUSH ---
const onFullState = (full) => {
  if (!full || full.id !== tableId) return;
  setTableState((prev) => mergeFullSnapshot(prev, full));
  gotSnapshotRef.current = true;
  if (Number.isInteger(full?.heroSeatIndex)) {
    gotHeroRef.current = true;
  }
  console.log('[CL] full state pushed', { id: full.id, seats: full?.seats?.length });
};

pokerSocket.on('table:state', onFullState);




// первый вход
rejoinRoomAndSnapshot();

// после любого переподключения сокета — снова вступаем в комнату и берём снапшот
pokerSocket.on('connect', rejoinRoomAndSnapshot);
pokerSocket.on('reconnect', rejoinRoomAndSnapshot);



return () => {
  pokerSocket.off('table:update', onUpdate);
  pokerSocket.off('table:private', onPrivate);
  pokerSocket.off('connect', rejoinRoomAndSnapshot);
  pokerSocket.off('reconnect', rejoinRoomAndSnapshot);
  pokerSocket.off('table:state', onFullState);

  // try { pokerSocket.emit('table:leave', { tableId }); } catch {}
  try { safeLeaveTable(tableId, { navigateAfter: false }); } catch {}

  gotSnapshotRef.current = false;
  gotHeroRef.current = spectator;
};
}, [tableId, setTableState, navigate, safeLeaveTable]);










const bbVal      = Number(tableState?.blinds?.bb || 0);




useEffect(() => {
  // Когда стол ушёл в waiting — новая раздача ещё не началась, флаг можно обнулить
  if (tableState?.phase === 'waiting') {
    requestedPostBBRef.current = false;
  }
}, [tableState?.phase]);


useEffect(() => {
  const n = tableState?.seatsMax || 6;
  if (!Array.isArray(seatRefs.current) || seatRefs.current.length !== n) {
    seatRefs.current = new Array(n).fill(null); // места под DOM элементы
  }
}, [tableState?.seatsMax]);




useEffect(() => {
  const la = tableState?.lastAction;
  if (!la || !potRef.current || !tableRef.current) return;

  // сервер иногда шлёт put > 0, хотя это BB-check → проверим реальное списание
  const idx = Number(la.idx);
  const put = Number(la.put || 0);
  if (!(put > 0)) return;

  // сколько реально списалось со стека
  const currStack = Number(tableState?.seats?.[idx]?.stack ?? NaN);
  const prevStack = Number(prevStacksRef.current[idx] ?? NaN);
  const spent = (Number.isFinite(prevStack) && Number.isFinite(currStack)) ? (prevStack - currStack) : 0;

  // BB-check в лимп-банке приходит как "call" с put=BB, но фишки не довносились
  const isBBCheck =
    tableState?.phase === 'preflop' &&
    idx === tableState?.bbIndex &&
    Math.abs((tableState?.bets?.[idx] || 0) - (tableState?.currentBet || 0)) < 1e-6;

  if (spent <= 0.005 || isBBCheck) return; // ✋ не рисуем полёт, если реально ничего не списалось

  const fromEl = seatRefs.current[idx];
  if (!fromEl) return;

  const from = getCenter(fromEl, tableRef.current);
  const to   = getCenter(potRef.current, tableRef.current);

  const id  = `act-${Date.now()}-${Math.random()}`;
  const dx  = to.x - from.x;
  const dy  = to.y - from.y;

  setFlyingChips(prev => [...prev, { id, x: from.x, y: from.y, dx: 0, dy: 0, opacity: 0.6 }]);
  requestAnimationFrame(() => {
    setFlyingChips(prev => prev.map(ch => ch.id === id ? { ...ch, dx, dy, opacity: 1 } : ch));
  });
  setTimeout(() => {
    setFlyingChips(prev => prev.filter(ch => ch.id !== id));
  }, 650);
}, [tableState?.lastAction?.idx, tableState?.lastAction?.put]);


useEffect(() => {
  if (!tableState?.__collecting || !tableRef.current || !potRef.current) return;

  const to = getCenter(potRef.current, tableRef.current);
  const adds = [];

  (tableState.bets || []).forEach((amt, i) => {
    if (!amt || amt <= 0) return;
    const fromEl = seatRefs.current[i];
    if (!fromEl) return;
    const from = getCenter(fromEl, tableRef.current);

    const id = `col-${i}-${Date.now()}`;
    adds.push({ id, x: from.x, y: from.y, dx: to.x - from.x, dy: to.y - from.y, opacity: 1 });
  });

  if (!adds.length) return;
  setFlyingChips((prev) => [...prev, ...adds]);

  // убрать весь набор через COLLECT_TO_POT_MS
  const timer = setTimeout(() => {
    setFlyingChips((prev) => prev.filter(ch => !adds.some(a => a.id === ch.id)));
  }, 680); // чуть больше CSS-перехода (см. стиль ниже)
  return () => clearTimeout(timer);
}, [tableState?.__collecting]);


function setEntryMode(mode) {
  // mode: 'waitBB' | 'postBB'
  const st = tableState;
  const idx = mySeatIndex; // ← наше место

  if (!st?.id) return;

  // если по каким-то причинам место ещё не определено — не дергаем сервер
  if (idx == null) {
    alert('Сначала сядьте за стол.');
    return;
  }

    // 🔒 новая защита: нельзя менять режим входа с нулевым стеком
  const seat = st.seats?.find?.(x => x?.seatIndex === idx);
  const stack = Number(seat?.stack || 0);
  if (stack <= 0) {
    console.warn('[entryMode] blocked: zero stack');
    return;
  }
  ensurePokerAuthAndConnect();
  pokerSocket.emit(
    'table:setEntryMode',
    { tableId: st.id, seatIndex: idx, mode }, // ← ВАЖНО: добавили seatIndex
    (res) => {
      if (!res?.ok) {
        console.warn('setEntryMode error:', res?.error, { tableId: st.id, seatIndex: idx, mode });
        alert(mapErr(res?.error));
      } else {
        console.log('[CL] entryMode set:', mode, 'for seat', idx);
        if (mode === 'postBB') requestedPostBBRef.current = true;
        if (mode === 'waitBB') requestedPostBBRef.current = false; 
      }
    }
  );
}





const onRevealCardsForSeat = (seatIndex) => {
  const cards = tableState?.hands?.[seatIndex];
  if (!Array.isArray(cards) || cards.length !== 2) return;
  // локальный оптимистичный показ
  revealTempLocal(seatIndex, cards, 3000);
  // запрос серверу разослать всем
  try {
    ensurePokerAuthAndConnect();
   pokerSocket.emit(
    'table:revealTemp',
    { tableId: tableState?.id, seatIndex, ms: 3000 },
    (resp) => {
      if (!resp?.ok) {
        console.warn('[revealTemp] rejected:', resp?.error);
      }
    }
  );
  } catch {}
};



const seats = useMemo(() => {
  const n = Number(tableState?.seatsMax || 0);
  return new Array(n).fill(0).map((_, i) => {
    const s = (tableState?.seats || []).find(x => x?.seatIndex === i) || {};
    const sittingOut = !!(s.sittingOut ?? tableState?.sittingOut?.[i] ?? tableState?.waitForBB?.[i] ?? false);
    const waitForBB  = !!(s.waitForBB  ?? tableState?.waitForBB?.[i] ?? false);

    return {
      // важно: прокидываем ВСЁ, что пришло с сервера (включая avatarPath/avatarURL/…)
      ...s,

      // а дальше поверх — наши вычисляемые/нормализованные поля
      seatIndex: i, // на всякий
      username: s.username ?? null,
      stack: Number(s.stack ?? 0),
      isHero: Boolean(tableState?.heroSeatIndex === i || s.isHero),
      sittingOut,
      waitForBB,
      // avatarVer могут звать по-разному — оставим как есть и нормализуем в avatarUrlForSeat
      avatarVer: Number(s.avatarVer ?? s.avatar_version ?? s.avatarRevision ?? 0),
    };
  });
}, [tableState]);



const betStep = useMemo(() => {
  const sb = Number(tableState?.blinds?.sb ?? 0.01);
  // ограничим минимумом 0.01 (под твою «работу в центах»)
  const step = (sb > 0 ? sb : 0.01);
  // подрезаем до двух знаков после запятой, чтобы не ловить 0.009999...
  return Math.round(step * 100) / 100;
}, [tableState?.blinds?.sb]);



  // рядом с seats/mySeatIndex
const activePlayers = useMemo(() => {
  return seats.filter(s => s.username && Number(s.stack) > 0 && !s.sittingOut).length;
}, [seats]);

  // const mySeatIndex = useMemo(() => {
  //   const s = seats.find(x => x.username === username && x.username);
  //   return s ? s.seatIndex : null;
  // }, [seats, username]);
  const mySeatIndex = useMemo(() => {
  if (Number.isInteger(tableState?.heroSeatIndex)) return tableState.heroSeatIndex;
  const s = seats.find(x => x?.username === username);
  return s ? s.seatIndex : null;
}, [seats, username, tableState?.heroSeatIndex]);
 
const mySeatFull = useMemo(() => {
  if (!Array.isArray(tableState?.seats)) return null;
  if (mySeatIndex == null) return null;
  return tableState.seats.find(s => s?.seatIndex === mySeatIndex) || null;
}, [tableState?.seats, mySeatIndex]);



const myStackNow = useMemo(
  () => Number(tableState?.seats?.[mySeatIndex]?.stack || 0),
  [tableState?.seats, mySeatIndex]
);



// 🧩 я сейчас реально в раздаче (карманка есть и не сфолден)
const isInHandNow = useMemo(() => {
  const st = tableState;
  const idx = mySeatIndex;
  if (!st || idx == null) return false;
  const hasHand   = Array.isArray(st?.hands?.[idx]);
  const isFolded  = !!st?.folded?.[idx];
  return (st.phase !== 'waiting') && hasHand && !isFolded;
}, [tableState, mySeatIndex]);




// мы "вне раздачи" если сидим за столом, идёт раздача и у нас waitForBB/sittingOut
// или просто нет карманки в текущей раздаче
// const isSittingOutNow = useMemo(() => {
//   const st  = tableState;
//   const idx = mySeatIndex;
//   if (!st || idx == null) return false;

//   const seat  = mySeatFull || st.seats?.find?.(x => x?.seatIndex === idx);
//   const stack = Number(seat?.stack || 0);

//   // 🔒 КЛЮЧ: при нулевом стеке не показываем режимы входа (ждать/post BB)
//   if (stack <= 0) return false;

//   return Boolean(
//     seat?.sittingOut ||
//     seat?.waitForBB ||
//     st?.sittingOut?.[idx] ||
//     st?.waitForBB?.[idx] ||
//     (st.phase !== 'waiting' && !Array.isArray(st.hands?.[idx])) // идёт раздача, а карманки нет
//   );
// }, [tableState, mySeatIndex, mySeatFull]);

// мы считаемся "вне раздачи" (для кнопок Ждать BB / Поставить BB),
// только если сервер ЯВНО пометил место как sittingOut или waitForBB
const isSittingOutNow = useMemo(() => {
  const st  = tableState;
  const idx = mySeatIndex;
  if (!st || idx == null) return false;

  const seat  = mySeatFull || st.seats?.find?.(x => x?.seatIndex === idx);
  if (!seat) return false;

  const stack = Number(seat.stack || 0);

  // при нулевом стеке режимы входа не показываем
  if (stack <= 0) return false;

  const sOut =
    seat.sittingOut ||
    seat.waitForBB ||
    st.sittingOut?.[idx] ||
    st.waitForBB?.[idx];

  // ⚠️ ВАЖНО:
  // больше НЕ смотрим на "нет карманки в текущей раздаче",
  // чтобы кнопки НЕ мигали между раздачами и после обычного фолда
  return Boolean(sOut);
}, [tableState, mySeatIndex, mySeatFull]);


  const amToAct = mySeatIndex !== null && tableState?.toActIndex === mySeatIndex && tableState?.phase !== 'showdown';
//   const allowed = useMemo(() => computeAllowedClient(tableState, mySeatIndex), [tableState, mySeatIndex]);

// const myBetNow = Number((tableState?.bets || [])[mySeatIndex] || 0);
// const canBetRaise = (Number(allowed?.callAmount || 0) > 0)
//   ? (Number(allowed?.minRaiseTo || 0) > 0 && Number(allowed?.maxRaiseTo || 0) > myBetNow)
//   : (Number(allowed?.minBet || 0) > 0 && Number(allowed?.maxRaiseTo || 0) > myBetNow);
const allowed = useMemo(() => computeAllowedClient(tableState, mySeatIndex), [tableState, mySeatIndex]);

const myBetNow = Number((tableState?.bets || [])[mySeatIndex] || 0);
const toCall   = Number(allowed?.callAmount || 0);
const currBet  = Number(tableState?.currentBet || 0);

// Игрок имеет право на BB-опцию (как реальный BB в лимп-банке),
// если он либо настоящий BB, либо вошёл "postBB" в текущей раздаче.
const hasBBOptionLike =
  tableState?.phase === 'preflop' &&
  toCall === 0 &&
  currBet > 0 &&
  myBetNow === currBet &&                // у меня уже лежит "живой" BB
  (tableState?.bbIndex === mySeatIndex || requestedPostBBRef.current);



// const raiseMode = (toCall > 0) || hasBBOptionLike;

// const canBetRaise =
//   Number(allowed?.maxRaiseTo || 0) > myBetNow &&
//   (
//     // обычный рейз (есть колл)
//     (toCall > 0 && Number(allowed?.minRaiseTo || 0) > myBetNow) ||
//     // обычный бет (постфлоп без ставки)
//     (toCall === 0 && currBet === 0 && Number(allowed?.minBet || 0) > myBetNow) ||
//     // BB-опция в лимп-банке: либо настоящий BB, либо вошёл через postBB
//     (hasBBOptionLike && Number(allowed?.minRaiseTo || 0) > myBetNow)
//   );
// ✳️ Наш спорный кейс: ...
// режим панели: рейз (есть колл или BB-опция) / бет (пустой банк)
const raiseMode = (toCall > 0) || hasBBOptionLike;

// базовый минимум/максимум для диапазона ставки
const minForRange = raiseMode
  ? Number(allowed?.minRaiseTo || 0)
  : Number(allowed?.minBet || 0);

const maxForRange = Number(allowed?.maxRaiseTo || 0);

// 👉 здесь мы жёстко запрещаем рейз, если сервер сказал "мин == макс" или "макс == myBet"
const canRaiseByRange =
  maxForRange > 0 &&          // вообще есть верхняя граница
  maxForRange > myBetNow &&   // можно поставить больше, чем уже стоит
  maxForRange > minForRange;  // диапазон [min,max] не выродился в точку

// Можно ли вообще открывать бет/рейз
const canBetRaise =
  canRaiseByRange &&
  (
    // обычный рейз (есть колл)
    (toCall > 0 && Number(allowed?.minRaiseTo || 0) > myBetNow) ||
    // обычный бет (постфлоп без ставки)
    (toCall === 0 && currBet === 0 && Number(allowed?.minBet || 0) > myBetNow) ||
    // BB-опция в лимп-банке
    (hasBBOptionLike && Number(allowed?.minRaiseTo || 0) > myBetNow)
  );


  // ✅ Стек героя берём из seats (он у тебя нормализован по индексам)

  // ✅ Стек героя берём из seats
const myStack = Number(seats?.[mySeatIndex]?.stack || 0);

// “raise to” после олл-ина (текущая моя ставка + остаток стека)
const allInTo = myBetNow + myStack;

// ✅ Ключ: можно ли вообще увеличить свою ставку (т.е. рейз/бет разрешён правилами/ситуацией)
// Если HU и оппонент уже all-in, твой computeAllowedClient делает maxRaiseTo = myBetNow,
// значит увеличить нельзя — и кнопку All-in показывать НЕ нужно.
const EPS = 1e-6;
const canIncreaseBet = Number(allowed?.maxRaiseTo || 0) > (myBetNow + EPS);

// ✅ Олл-ин как отдельную кнопку показываем только когда это реально "увеличение",
// а не ситуация "только колл/пас"
const canAllInOnly =
  amToAct &&
  mySeatIndex != null &&
  myStack > 0 &&
  canIncreaseBet &&
  (
    // банк пустой → олл-ин как бет
    (currBet === 0 && toCall === 0) ||
    // есть ставка → олл-ин должен превысить текущую ставку
    (allInTo > currBet)
  );

// const myStack = Number(seats?.[mySeatIndex]?.stack || 0);

// // “raise to” после олл-ина (текущая моя ставка + остаток стека)
// const allInTo = myBetNow + myStack;

// // ✅ Олл-ин как действие показываем, даже когда minRaiseTo == maxRaiseTo.
// // Важно: если олл-ин НЕ превышает текущую ставку — это просто call-all-in,
// // тогда отдельная кнопка не нужна (у тебя уже есть Call на весь стек).
// const canAllInOnly =
//   amToAct &&
//   mySeatIndex != null &&
//   myStack > 0 &&
//   (
//     // банк пустой → олл-ин как бет
//     (currBet === 0 && toCall === 0) ||
//     // есть ставка → олл-ин должен превысить текущую ставку (иначе это просто call)
//     (allInTo > currBet)
//   );

  const [betOpen, setBetOpen] = useState(false);






useEffect(() => {
  const la = tableState?.lastAction;
  if (!la) return;

  // Если сам объект lastAction не изменился — не реагируем
  if (prevFoldLaObjRef.current === la) return;
  prevFoldLaObjRef.current = la;

  // 🚫 не играем во время дилерских шагов и в 'waiting'

 if (tableState?.phase === 'waiting'
   || tableState?.__collecting
   || tableState?.__revealPending
   || tableState?.__runoutPending) return;

  const t = String(la.type || '').toLowerCase();
  if (t !== 'fold') return;

  const idx = Number(la.idx);

  // Если это наш fold и мы уже сыграли локальный звук по клику — пропускаем серверный дубль
  if (idx === mySeatIndex && skipNextHeroFoldRef.current) {
    skipNextHeroFoldRef.current = false;
    return;
  }

  // антидубль в рамках раздачи
  const sig = `${tableState?.__turnId || 0}:${idx}:fold`;
  if (lastPlayedFoldRef.current === sig) return;
  lastPlayedFoldRef.current = sig;

  try { play('fold'); } catch (e) { console.warn('SFX fold failed', e); }

}, [
  play,
  tableState?.lastAction, // слушаем только сам объект действия
  tableState?.phase,      // чтобы игнорить 'waiting'
  mySeatIndex             // нужен для фильтра героя
]);







useEffect(() => {


   const mgr = pokerSocket.io;
   const PING_INTERVAL = mgr?.opts?.pingInterval ?? 25000; // по умолчанию ~25s
   const PING_TIMEOUT  = mgr?.opts?.pingTimeout  ?? 20000; // по умолчанию ~20s
   const STALE_LIMIT_MS = Math.max(80000, PING_INTERVAL + PING_TIMEOUT + 10000); // минимум ~80s
  // 2.1 Любое входящее событие от сервера помечаем как «живой канал»
  const onAny = () => { lastEvtRef.current = Date.now(); };
  pokerSocket.onAny(onAny);



  // 👇 считаем «живым» каждый ping/pong от socket.io
 
   const markAlive = () => { lastEvtRef.current = Date.now(); };
   // socket.io-client v3/v4: события менеджера
   try {
     mgr.on('ping', markAlive);
     mgr.on('pong', markAlive);
   } catch {}
   // подстраховка: на уровне engine.io (если ping/pong не пробрасываются как события)
   try {
     mgr.engine.on('packet', (p) => {
       if (p?.type === 'ping' || p?.type === 'pong') markAlive();
     });
   } catch {}
  // 2.2 Браузерные online/offline
//   const onOffline = () => setNetMsg('Нет соединения (браузер оффлайн). Пытаемся восстановить…');
// const onOnline  = () => {
//   setNetMsg('Сеть появилась. Переподключаемся…');
//   hardReconnect();                            // ← сразу пытаемся вернуться
// };
const onOffline = () => showNet('Нет соединения (браузер оффлайн). Пытаемся восстановить…');
const onOnline  = () => {
  showNet('Сеть появилась. Переподключаемся…');
  hardReconnect();
};

  window.addEventListener('offline', onOffline);
  window.addEventListener('online', onOnline);


const onConnect = () => {
   lastEvtRef.current = Date.now(); // 👈 добавь
   lostSinceRef.current = null;
  flashNet('Связь восстановлена', 2500); // короткая плашка и сама исчезнет
};
const onDisconnect = (reason) => {
  lostSinceRef.current = Date.now();
  showNet(`Связь потеряна${reason ? ` (${reason})` : ''}. Пытаемся восстановить…`); // висит постоянно
  if (String(reason).includes('io server disconnect')) {
    try { pokerSocket.connect(); } catch {}
  }
};

const onReconnAttempt = (n) => showNet(`Переподключение… попытка ${n}`);
const onReconnOk      = () => {
  lostSinceRef.current = null;
  flashNet('Связь восстановлена', 2500);
};
const onReconnErr     = () => showNet('Переподключение не удалось. Пробуем ещё…');


  pokerSocket.on('connect', onConnect);
  pokerSocket.on('disconnect', onDisconnect);
  pokerSocket.io.on('reconnect_attempt', onReconnAttempt);
  pokerSocket.io.on('reconnect', onReconnOk);
  pokerSocket.io.on('reconnect_error', onReconnErr);

  // 2.4 «Сторожок» от «тихих» обрывов и обратный отсчёт до кика
  const t = setInterval(() => {
    const now = Date.now();



     // Если «давно не слышно», просто покажем баннер — менеджер сам отвалится по pingTimeout
     if (pokerSocket.connected && (now - lastEvtRef.current) > STALE_LIMIT_MS) {
       showNet('Похоже, связь подвисла. Проверяем соединение…');
       // 👆 ничего насильно не закрываем: socket.io сам обработает таймаут/реconnect
     }

// if (pokerSocket.connected && (now - lastEvtRef.current) > STALE_MS) {
//   showNet('Похоже, связь подвисла. Пытаемся переподключиться…');
//   try { pokerSocket.io?.engine?.close(); pokerSocket.connect(); } catch {}
// }

if (!pokerSocket.connected && lostSinceRef.current) {
  const left = Math.max(0, KICK_MS - (now - lostSinceRef.current));
  const sec  = Math.ceil(left / 1000);
  showNet(`Нет соединения. Восстановите связь. Авто-фолд/высадка через ${sec} сек.`);
}

  }, 1000);

  return () => {
    clearInterval(t);
    pokerSocket.off('connect', onConnect);
    pokerSocket.off('disconnect', onDisconnect);
    pokerSocket.io.off('reconnect_attempt', onReconnAttempt);
    pokerSocket.io.off('reconnect', onReconnOk);
    pokerSocket.io.off('reconnect_error', onReconnErr);
    window.removeEventListener('offline', onOffline);
    window.removeEventListener('online', onOnline);
    pokerSocket.offAny(onAny);
    try {
       mgr.off('ping', markAlive);
       mgr.off('pong', markAlive);
       mgr.engine.off('packet'); // если выше навесили
     } catch {}
  };
}, []);






function computeAllowedClient(st, seatIndex) {
  if (!st || seatIndex == null || seatIndex < 0) return { canCheck:false, callAmount:0, minBet:0, minRaiseTo:0, maxRaiseTo:0 };
  const seatsMax = Number(st.seatsMax || 0);
  if (seatIndex >= seatsMax) return { canCheck:false, callAmount:0, minBet:0, minRaiseTo:0, maxRaiseTo:0 };

  const s = st.seats?.find?.(x => x?.seatIndex === seatIndex);
  // if (!s?.username || st.folded?.[seatIndex] || !(s.stack > 0)) return { canCheck:false, callAmount:0, minBet:0, minRaiseTo:0, maxRaiseTo:0 };
    // if (!s?.username || st.folded?.[seatIndex] || !(s.stack > 0) || s.sittingOut) {
    const sOut = Boolean(s?.sittingOut || s?.waitForBB || st?.sittingOut?.[seatIndex] || st?.waitForBB?.[seatIndex]);
    if (!s?.username || st.folded?.[seatIndex] || !(s.stack > 0) || sOut) {
    return { canCheck:false, callAmount:0, minBet:0, minRaiseTo:0, maxRaiseTo:0 };
  }

  // блок во время дилера/ран-аута
  if (st.__revealPending || st.__collecting || st.__runoutPending) {
    return { canCheck:false, callAmount:0, minBet:0, minRaiseTo:0, maxRaiseTo:0 };
  }

  const myBet = Number((st.bets || [])[seatIndex] || 0);
  const currentBet = Number(st.currentBet || 0);
  const toCallFull = Math.max(0, currentBet - myBet); 
  const bb = Number(st?.blinds?.bb || 1);

  // Вспомогалки из сервера:
 const aliveNotFolded = () => {
  const res = [];
  for (let i = 0; i < seatsMax; i++) {
    const si = st.seats?.find?.(x => x?.seatIndex === i);
    // if (si?.username && !st.folded?.[i] && si.stack > 0 && !si.sittingOut) {
     const siOut = Boolean(si?.sittingOut || si?.waitForBB || st?.sittingOut?.[i] || st?.waitForBB?.[i]);
     if (si?.username && !st.folded?.[i] && si.stack > 0 && !siOut) {
      res.push(i);
    }
  }
  return res;
};

  const allCanActMatched = () => {
    const target = currentBet || 0;
    for (const i of aliveNotFolded()) {
      const bet = Number((st.bets || [])[i] || 0);
      if (Math.round(bet*100) !== Math.round(target*100)) return false;
    }
    return true;
  };
  const allActiveAllIn = () => {
    const alive = aliveNotFolded();
    if (alive.length < 2) return false;
    if (!allCanActMatched()) return false;
    const canAct = alive.filter(i => (st.seats?.find?.(x => x?.seatIndex === i)?.stack || 0) > 0);
    return canAct.length <= 1;
  };

  if (allActiveAllIn()) {
    return { canCheck: toCallFull === 0, callAmount: Math.min(toCallFull, s.stack), minBet:0, minRaiseTo:0, maxRaiseTo: myBet };
  }


  // 🔒 HU-замок на клиенте: есть что коллировать, но у всех остальных стек == 0 → только Fold/Call

    // короткий стек против ставки/оллина: рейз невозможен
  if (toCallFull > 0 && s.stack <= toCallFull) {
    return { canCheck: false, callAmount: s.stack, minBet: 0, minRaiseTo: 0, maxRaiseTo: myBet };
  }


{
  let othersInHand = 0, othersWithChips = 0;
  for (let i = 0; i < seatsMax; i++) {
    if (i === seatIndex) continue;
    const si = st.seats?.find?.(x => x?.seatIndex === i);
    if (!si?.username || st.folded?.[i] || si?.sittingOut || si?.waitForBB || st?.sittingOut?.[i] || st?.waitForBB?.[i]) continue;

    othersInHand++;
    if (Number(si.stack) > 0) othersWithChips++;
  }
  const raiseLockedHU = (toCallFull > 0 && othersInHand >= 1 && othersWithChips === 0);
  if (raiseLockedHU) {
    return {
      canCheck: false,
      callAmount: Math.min(toCallFull, s.stack),
      minBet: 0,
      minRaiseTo: 0,
      maxRaiseTo: myBet, // важно: = myBet, чтобы UI понял, что рейз невозможен
    };
  }
}


  const minBet = currentBet === 0 ? Math.min(bb, myBet + s.stack) : 0;

  let minRaiseTo = 0;
  const lastRaiseSize = Number(st.lastRaiseSize || bb);
  if (currentBet > 0) {
    const inc = Math.max(lastRaiseSize, bb);
    minRaiseTo = Math.min(currentBet + inc, myBet + s.stack);
  } else {
    minRaiseTo = Math.max(bb, currentBet + bb);
  }
  const maxRaiseTo = myBet + s.stack;

  return {
    canCheck: toCallFull === 0,
    callAmount: Math.min(toCallFull, s.stack),
    minBet, minRaiseTo, maxRaiseTo
  };
}



  // Сесть за место
// Сесть за выбранное место СРАЗУ с бай-ином
const handleJoinSeat = (seatIndex) => {
  if (MOCK_ONLY) return;
  const st = tableState;
  if (!st) return;

  // возьмём лимиты из снапшота (см. п.1.1), а если их ещё нет — fallback 50–100BB
  const bb  = Number(st?.blinds?.bb || 0);
  const min = Number(st?.minBuyIn ?? (bb ? bb * 50 : 0));
  const max = Number(st?.maxBuyIn ?? (bb ? bb * 100 : min));

  let buyIn = Number(prompt(`Сколько внести? (мин $${min}${max ? `, макс $${max}` : ''})`, String(min)));
  if (!Number.isFinite(buyIn) || buyIn < min) { alert('Недопустимая сумма.'); return; }
  if (max && buyIn > max) { alert(`Максимум $${max}.`); buyIn = max; }

  ensurePokerAuthAndConnect();
 pokerSocket.emit('table:joinSeat', { tableId: st.id, seatIndex: Number(seatIndex), buyIn }, (resp) => {
   if (!resp) return;
   if (resp.error) { alert(resp.message || resp.error); return; }
   if (resp.ok) {
     // 1) Публичный снапшот мерджим безопасно (НЕ затираем приватку)
     if (resp.snapshot) {
       setTableState((prev) => mergeFullSnapshot(prev, resp.snapshot));
       console.log('[CL] joinSeat: merged snapshot', {
         id: resp.snapshot?.id, seatsMax: resp.snapshot?.seatsMax
       });
     }
     // 2) Если сервер прислал приватные поля отдельно — доклеим и их
     if (Number.isInteger(resp.heroSeatIndex)) {
       setTableState((prev) => mergeFullSnapshot(prev, {
         heroSeatIndex: resp.heroSeatIndex,
         heroHand: resp.heroHand, // ок, если null — mergeFullSnapshot не будет ломать руки
       }));
       gotHeroRef.current = true;
       console.log('[CL] hero: ready-by-join-cb', {
         hero: resp.heroSeatIndex,
         hh: Array.isArray(resp.heroHand) && resp.heroHand.length === 2
       });
     }
   }
 });
};











const minSlider  = raiseMode ? Number(allowed?.minRaiseTo || 0) : Number(allowed?.minBet || 0);
const maxSlider  = Number(allowed?.maxRaiseTo || 0) || 0;
const quick1 = Math.min(Math.max(Math.max(minSlider, bbVal), 0), maxSlider || bbVal);
const quick3 = Math.min(Math.max(Math.max(minSlider, bbVal * 3), 0), maxSlider || bbVal * 3);

useEffect(() => {
  // при входе на новый стол начинаем "с чистого листа"
  gotHeroRef.current = spectator; // зрителю не нужен приватный герой
  gotSnapshotRef.current = false;
  console.log('[CL] table switch: reset hero/snapshot flags', { tableId });
}, [tableId, spectator]);




const playBetAndBroadcast = useCallback(() => {
   // локально — мгновенно
   try { play('bet'); } catch {}
   // следующий прилёт из комнаты (эхо) не дублируем
   skipNextBetEchoRef.current = true;
   // рассылаем всем за столом
   try {
     ensurePokerAuthAndConnect();
     pokerSocket.emit('table:sfx', { tableId: tableState?.id, key: 'bet' });
   } catch {}
 }, [play, tableState?.id]);



useEffect(() => {
   const onSfx = (payload) => {
     if (!payload || payload.tableId !== tableId) return;
     const key = String(payload.key || '');
    //  if (key !== 'bet') return;

    //  // если это наше собственное эхо после локального клика — пропускаем один раз
    //  if (skipNextBetEchoRef.current) {
    //    skipNextBetEchoRef.current = false;
    //    return;
    //  }
    //  try { play('bet'); } catch {}

    if (key === 'bet') {
      // эхо после локального клика — пропускаем один раз
      if (skipNextBetEchoRef.current) { skipNextBetEchoRef.current = false; return; }
      try { play('bet'); } catch {}
      return;
    }
    if (key === 'check') {
      // эхо после локального клика — пропускаем один раз
      if (skipNextCheckEchoRef.current) { skipNextCheckEchoRef.current = false; return; }
      try { play('check'); } catch {}
      return;
    }

   };

   pokerSocket.on('table:sfx', onSfx);
   return () => {
     pokerSocket.off('table:sfx', onSfx);
   };
 }, [tableId, play]);

// ⏱️ ТАЙМЕР ХОДА: запускаем, когда мой ход; сбрасываем, когда не мой
useEffect(() => {
  if (turnTimerRef.current) {
    clearInterval(turnTimerRef.current);
    turnTimerRef.current = null;
  }

  // Кому-то сейчас нужно ходить?
  const somebodyActs =
    tableState?.toActIndex != null &&
    tableState?.phase !== 'showdown' &&
    tableState?.phase !== 'waiting';
  if (!somebodyActs) { setTurnMsLeft(0); return; }

  // Берём стартовые значения от сервера (если есть), иначе полный бюджет хода
  const serverLeftMs  = Number(tableState?.toActMsLeft ?? NaN);
  const serverTotalMs = Number(tableState?.turnTimeMs ?? tableState?.timebank?.perTurnMs ?? NaN);
  const total = (Number.isFinite(serverTotalMs) && serverTotalMs > 0) ? serverTotalMs : DEFAULT_TURN_MS;
  const left  = (Number.isFinite(serverLeftMs)  && serverLeftMs  > 0) ? serverLeftMs  : total;

  setTurnTotalMs(total);
  setTurnMsLeft(left);

  const startedAt  = performance.now();
  const plannedEnd = startedAt + left;
  turnTimerRef.current = setInterval(() => {
    setTurnMsLeft(Math.max(0, plannedEnd - performance.now()));
  }, 100);

  return () => {
    if (turnTimerRef.current) {
      clearInterval(turnTimerRef.current);
      turnTimerRef.current = null;
    }
  };
// важные зависимости — смена того, кто ходит/новая раздача/фаза/параметры таймера
}, [tableState?.toActIndex, tableState?.__turnId, tableState?.phase, tableState?.turnTimeMs, tableState?.toActMsLeft]);











const playCheckAndBroadcast = useCallback(() => {
  try { play('check'); } catch {}
  skipNextCheckEchoRef.current = true;
  try {
    ensurePokerAuthAndConnect();
    pokerSocket.emit('table:sfx', { tableId: tableState?.id, key: 'check' });
  } catch {}
}, [play, tableState?.id]);


 


// пересчёт дефолтного значения, когда наш ход/изменилась улица/лимиты
useEffect(() => {
  const bb = Number(tableState?.blinds?.bb || 0);
  const minBase = (raiseMode ? Number(allowed?.minRaiseTo || 0) : Number(allowed?.minBet || 0));
  const start = Math.max(minBase, bb);                    // минимум — хотя бы BB
  const max = Number(allowed?.maxRaiseTo || start);
  const clamped = Math.min(Math.max(start, minBase), max);
  setQuickAmount(roundToStep(clamped, minBase || betStep, betStep));
}, [
  amToAct, tableState?.__turnId,
  raiseMode, allowed?.minRaiseTo, allowed?.minBet, allowed?.maxRaiseTo,
  tableState?.blinds?.bb, betStep
]);








// 🔊 ЭФФЕКТ ЗВУКА ОТКРЫТИЯ КАРТ (флоп/тёрн/ривер)
// 🔊 ЭФФЕКТ ЗВУКА ОТКРЫТИЯ КАРТ (флоп/тёрн/ривер)
useEffect(() => {
  const turnId = tableState?.__turnId ?? 0;
  const phase  = String(tableState?.phase || 'waiting');
  const board  = Array.isArray(tableState?.board) ? tableState.board : [];
  const len    = board.length; // 0, 3, 4, 5

  // — фиксируем "прошлые" значения ДО любых апдейтов —
  const prevLen = lastBoardLenRef.current ?? 0;
  const prevSig = lastBoardSigRef.current ?? '';

  // новая раздача → обнуления
  if (seenTurnIdRef.current !== turnId) {
    seenTurnIdRef.current   = turnId;
    lastBoardLenRef.current = 0;
    lastBoardSigRef.current = '';
    lastPhaseRef.current    = 'waiting';
    if (dealSoundTimerRef.current) {
      clearTimeout(dealSoundTimerRef.current);
      dealSoundTimerRef.current = null;
    }
  }

  // сигнатура текущего борда (делаем её максимально "устойчивой")
  const nowSig = `${turnId}:${board.join('|')}`;

  // строгие условия: борд должен вырасти и рост соответствовать улице
  const grew  = len > prevLen;             // именно >, а не >=
  const stepF = (prevLen === 0 && len === 3 && phase === 'flop');
  const stepT = (prevLen === 3 && len === 4 && phase === 'turn');
  const stepR = (prevLen === 4 && len === 5 && phase === 'river');
  const stepOk = stepF || stepT || stepR;

  // реальная смена набора карт
  const sigChanged = nowSig !== prevSig;

  if (grew && stepOk && sigChanged) {
    const DEAL_DELAY_MS = 220;
    if (dealSoundTimerRef.current) {
      clearTimeout(dealSoundTimerRef.current);
      dealSoundTimerRef.current = null;
    }
    dealSoundTimerRef.current = window.setTimeout(() => {
      try { play('cartOpen'); } catch (e) { console.warn('SFX cartOpen failed', e); }
      dealSoundTimerRef.current = null;
    }, DEAL_DELAY_MS);
  }

  // — коммитим "текущее" в "прошлое" —
  lastBoardLenRef.current = len;
  lastBoardSigRef.current = nowSig;
  lastPhaseRef.current    = phase;

  return () => {
    if (dealSoundTimerRef.current) {
      clearTimeout(dealSoundTimerRef.current);
      dealSoundTimerRef.current = null;
    }
  };
}, [
  tableState?.board?.length, // звук триггерим только на рост борда…
  tableState?.phase,         // …и фазу (для контроля 0→3/3→4/4→5)
  tableState?.__turnId,      // новая раздача — собственная линия
  play                       // если sfx-контекст пересобрался
]);









// если у места нет avatar от сервера — попробуем файлы по нику
useEffect(() => {
  const need = (seats || [])
    .filter(s => s?.username && !s.avatar && !avatarCache[s.username])
    .map(s => s.username);

  const uniq = Array.from(new Set(need));
  if (!uniq.length) return;

  const exts = ['.webp', '.png', '.jpg', '.jpeg'];

  uniq.forEach((name) => {
    (async () => {
      for (const ext of exts) {
        const url = `${API_ORIGIN}/uploads/avatars/${encodeURIComponent(name)}${ext}`;
        if (await testImage(url)) {
          setAvatarCache(prev => ({ ...prev, [name]: url }));
          break;
        }
      }
    })();
  });
}, [seats, avatarCache]);

// useEffect(() => {
//   if (open) setToAmount(initialTo);
// }, [open, initialTo]);

 
const onFold = () => {
  skipNextHeroFoldRef.current = true;
  try { play('fold'); } catch (e) { console.warn('SFX fold failed', e); }
  sendAction('fold');
};


const onCheckCall = () => {
  const need = Number(allowed?.callAmount || 0);
  // sendAction(need > 0 ? 'call' : 'check'); 
  const isCall = need > 0;
  if (isCall) {
    // Мгновенный отклик инициатору; бродкаст от сервера всё равно придёт,
    // но защиту от дубля делает useEffect по lastAction (см. выше).
    try { play('koll'); } catch {}
  
  }
    else {
    // строго на клик по кнопке "Check"
    playCheckAndBroadcast();
  }
  sendAction(isCall ? 'call' : 'check');
};

// const onConfirmBetRaise = (toAmount) => {
//   setBetOpen(false);
//   sendAction(raiseMode ? 'raise' : 'bet', Number(toAmount || 0));
// };
// ВНИМАНИЕ: это внутри PokerTable, твоя функция уже есть.
// Просто убедись, что она округляет к сетке перед отправкой:
const onConfirmBetRaise = (toAmount) => {
  setBetOpen(false);
  const v = Number(toAmount || 0);
  // здесь min/max недоступны, округлим к «разумной» сетке SB,
  // сервер всё равно проверит, но клиент пошлёт красиво:
  const sb = Number(tableState?.blinds?.sb ?? 0.01);
  const step = (sb > 0 ? Math.round(sb * 100) / 100 : 0.01);
  // привязка к текущему min в панели уже сделана, поэтому тут достаточно
  // просто округлить к шагу, а сервер зажмёт по своему min/max
  const snapped = Math.round(v / step) * step;
  sendAction(raiseMode ? 'raise' : 'bet', Math.round(snapped * 100) / 100);
};


const onAllIn = () => {
  // (необязательно) мгновенный звук по клику
  try { play('allin'); } catch { try { play('raise'); } catch {} }

  // сервер сам поставит весь стек
  sendAction('allin');
};

// ОТКРЫТЬ панель ставки/рейза
const onClickBetRaise = () => {
  if (!canBetRaise) { alert('Ставка/рейз сейчас недоступны.'); return; }

  if (!amToAct) return; // на всякий случай
  const min = Number((allowed?.callAmount > 0 ? allowed?.minRaiseTo : allowed?.minBet) || 0);
  const max = Number(allowed?.maxRaiseTo || 0);
console.log('[DBG] allowed=', allowed, 
  'min=', (allowed.callAmount>0?allowed.minRaiseTo:allowed.minBet),
  'max=', allowed.maxRaiseTo,
  'myIdx=', mySeatIndex,
  'myBet=', (tableState?.bets||[])[mySeatIndex],
  'flags=', {rv:tableState?.__revealPending, col:tableState?.__collecting, ro:tableState?.__runoutPending});

  // если поставить нельзя — подскажем почему
  if (!(max > 0) || min > max) {
    console.log('[DBG] allowed=', allowed, 
  'min=', (allowed.callAmount>0?allowed.minRaiseTo:allowed.minBet),
  'max=', allowed.maxRaiseTo,
  'myIdx=', mySeatIndex,
  'myBet=', (tableState?.bets||[])[mySeatIndex],
  'flags=', {rv:tableState?.__revealPending, col:tableState?.__collecting, ro:tableState?.__runoutPending});

    alert('Ставка/рейз сейчас недоступны.');
    return;
  }
  setBetOpen(true);
};


 // ВСТАВЬ рядом с handleJoinSeat
const handleLeaveSeat = () => {
  const st = tableState;
  if (!st) return;
  ensurePokerAuthAndConnect();
  pokerSocket.emit('table:leaveSeat', { tableId: st.id }, (resp) => {
    if (!resp) return;
    if (resp.error) { alert(resp.message || resp.error); return; }
    if (resp.ok && resp.snapshot) setTableState(resp.snapshot);
  });
};




// ⬇️ ПОЛНАЯ ЗАМЕНА
const backToLobby = () => {
  const st = tableState;

  // нет стола
  if (!st?.id) {
    setTableState({});
    gotHeroRef.current = spectator;
    gotSnapshotRef.current = false; 

    ensurePokerAuthAndConnect();
    pokerSocket.emit('lobby:join');
    pokerSocket.emit('lobby:requestTables', () => {});
    navigate('/poker');
    return;
  }

  const myIdx = mySeatIndex;

  // зритель
  if (myIdx == null) {
    setTableState({});
    gotHeroRef.current = spectator;
    gotSnapshotRef.current = false;

    try { pokerSocket.emit('table:leave', { tableId: st.id }); } catch {}
    ensurePokerAuthAndConnect();
    pokerSocket.emit('lobby:join');
    pokerSocket.emit('lobby:requestTables', () => {});
    navigate('/poker');
    return;
  }

  // сидим
  let doLeave = true;
  let forceFold = false;

  if (isInHandNow) {
    doLeave = window.confirm(
      'Вы сейчас участвуете в раздаче. Если выйдете, ваши карты будут сброшены (пас), а стек вернется на баланс. Выйти?'
    );
    forceFold = doLeave;
  } else {
    doLeave = window.confirm('Уйти со стола и вернуться в лобби?');
  }
  if (!doLeave) return;

  ensurePokerAuthAndConnect();
  pokerSocket.emit('table:leaveSeat', { tableId: st.id, forceFold }, (resp) => {
    gotHeroRef.current = spectator;
    gotSnapshotRef.current = false;

    if (resp?.ok && resp.snapshot) setTableState(resp.snapshot);
    else setTableState({});

    setTempReveals({});
    seatRefs.current = [];
    setFlyingChips([]);

    try { pokerSocket.emit('table:leave', { tableId: st.id }); } catch {}

    // сразу подписываемся на лобби и тянем список
    pokerSocket.emit('lobby:join');
    pokerSocket.emit('lobby:requestTables', () => {});
    navigate('/poker');
  });
};



  function getCenter(el, root) {
  if (!el || !root) return { x: 0, y: 0 };
  const r = el.getBoundingClientRect();
  const rr = root.getBoundingClientRect();
  return { x: r.left - rr.left + r.width / 2, y: r.top - rr.top + r.height / 2 };
}

// Победители «по факту» из bestHands/details.
// Если серверный winners корректный — просто совпадёт.
const effectiveWinners = useMemo(() => {
  const det = tableState?.bestHands || tableState?.details;
  const srv = Array.isArray(tableState?.winners) ? tableState.winners : [];

  if (!det || typeof det !== 'object') return srv;

  const entries = Object.entries(det)
    .map(([k, v]) => [Number(k), v?.score])
    .filter(([, sc]) => Array.isArray(sc));

  if (!entries.length) return srv;

  let best = null;
  for (const [, sc] of entries) {
    if (!best || cmpScore(sc, best) > 0) best = sc;
  }
  return entries
    .filter(([, sc]) => cmpScore(sc, best) === 0)
    .map(([i]) => i);
}, [tableState?.bestHands, tableState?.details, tableState?.winners, tableState?.__turnId]);
 







  const renderSeat = (s) => {
    const taken = Boolean(s.username);
    // const isDealer = tableState?.buttonIndex === s.seatIndex;
    const showBlindBadges = (activePlayers >= 2) && tableState?.phase !== 'waiting';
    const isDealer = showBlindBadges && (tableState?.buttonIndex === s.seatIndex);  
    const isToAct = (tableState?.toActIndex === s.seatIndex) && tableState?.phase !== 'showdown';
    const last = (tableState?.lastAction?.idx === s.seatIndex) ? tableState?.lastAction : null;

// ⬇️ чтобы пустое место не считалось сфолдженным
const folded = taken && Boolean(tableState?.folded?.[s.seatIndex]);


// const isSB = tableState?.sbIndex === s.seatIndex;
// const isBB = tableState?.bbIndex === s.seatIndex;
const isSB     = showBlindBadges && (tableState?.sbIndex === s.seatIndex);
const isBB     = showBlindBadges && (tableState?.bbIndex === s.seatIndex);

// const isHeroSeat = (tableState?.heroSeatIndex === s.seatIndex) || s.isHero;
const isHeroSeat = (tableState?.heroSeatIndex === s.seatIndex);
// сервер временно раскрыл победителя?
const revealedByServer =
  Array.isArray(tableState?.revealSeats) && tableState.revealSeats.includes(s.seatIndex);
const publicCards = revealedByServer ? (tableState?.publicHands?.[s.seatIndex] || null) : null;

// победитель на шоудауне (бывает, что сервер не ставит revealAll, но есть winners)
// const winnerNow =
//   tableState?.phase === 'showdown' &&
//   Array.isArray(tableState?.winners) &&
//   tableState.winners.includes(s.seatIndex);
const winnerNow =
   tableState?.phase === 'showdown' &&
   effectiveWinners.includes(s.seatIndex); 
  // 🔝 Временный локальный/серверный показ имеет самый высокий приоритет
const tempCards = tempReveals?.[s.seatIndex]?.cards || null;

const visibleToTableNow =
  !!tempCards                      // временное раскрытие (клиент/сервер)
  || !!publicCards                 // сервер кратковременно раскрыл
  || !!tableState?.revealAll;      // сервер раскрыл всех

// итоговые карты для показа (по приоритетам)
const seatCards = (() => {
  // if (isHeroSeat) return tableState?.hands?.[s.seatIndex] || null;                       // приватка героя
  if (tempCards) return tempCards;                                       // ← приоритет #1
  if (isHeroSeat) return tableState?.hands?.[s.seatIndex] || null;       // приватка героя
  if (publicCards) return publicCards;                                                    // кратковременное раскрытие сервером
  if (tableState?.revealAll) return tableState?.hands?.[s.seatIndex] || null;            // полное раскрытие всех
  if (winnerNow) return tableState?.publicHands?.[s.seatIndex] || tableState?.hands?.[s.seatIndex] || null; // фолбэк для победителя
  return null;
})();



// ① Готовим узел аватарки, чтобы вставить его внутрь плашки
// ① Аватар ИЛИ таймер-цифра вместо него на своём месте (когда наш ход)
// ① Аватар ИЛИ таймер-цифра вместо него на своём месте (когда наш ход)
// ① Аватар (всегда) + таймер-обводка/цифра поверх (когда ход этого места)
const seatAvatarNode = (() => {
  const seatWithHeroFlag = { ...s, isHero: isHeroSeat };

  // 1) Кандидаты на URL
  const urlFromSeat = avatarUrlForSeat(
    seatWithHeroFlag,
    heroAvatarUrl,
    heroAvatarVer,
    avatarCache
  );
  const urlFromCache = s.username ? avatarCache[s.username] : null;

  // 2) Если по этому нику у нас уже был onError — не пытайся снова, сразу покажем инициалы
const candidate = urlFromSeat || urlFromCache || null;
   const urlKey = candidate || '';
   const badImg = !!imgError[urlKey];
   const url = badImg ? null : candidate;

  const initials = (s.username || '—').trim().slice(0, 2).toUpperCase();
  const isToActSeat = (tableState?.toActIndex === s.seatIndex) && tableState?.phase !== 'showdown';

  // --- таймер для текущего места ---
  // const serverLeftRaw  = Number(tableState?.toActMsLeft ?? tableState?.turnMsLeft ?? NaN);
  // const serverTotalRaw = Number(tableState?.turnTimeMs   ?? tableState?.timebank?.perTurnMs ?? NaN);

  // const serverTotal = Number.isFinite(serverTotalRaw) && serverTotalRaw > 0
  //   ? serverTotalRaw
  //   : DEFAULT_TURN_MS;

  // // для чужого хода сервер часто НЕ даёт остаток → чтобы не было вечного красного 0,
  // // используем "полный круг" (зелёный). Для своего хода — наш локальный тик.
  // const leftMs = isToActSeat
  //   ? (amToAct
  //       ? turnMsLeft
  //       : (Number.isFinite(serverLeftRaw) && serverLeftRaw > 0 ? serverLeftRaw : serverTotal))
  //   : 0;

  // const totalMs = isToActSeat
  //   ? (amToAct ? turnTotalMs : serverTotal)
  //   : DEFAULT_TURN_MS;
  const leftMs  = isToActSeat ? turnMsLeft  : 0;
  const totalMs = isToActSeat ? turnTotalMs : DEFAULT_TURN_MS;
  // геометрия кольца
  const R = 18;
  const C = 2 * Math.PI * R;

  // доля прошедшего времени (0..1)
  const progress  = 1 - (leftMs / Math.max(1, totalMs));
  const leftRatio = (leftMs / Math.max(1, totalMs));

  let ringColor = '#22c55e';                  // зелёный
  if (leftRatio <= 0.66 && leftRatio > 0.33) ringColor = '#eab308'; // жёлтый
  if (leftRatio <= 0.33)                     ringColor = '#ef4444'; // красный

  const dash = `${Math.max(0.0001, progress) * C} ${C}`;
  const secs = Math.max(0, Math.ceil(leftMs / 1000));

  // рисуем кольцо только когда ход этого места
  const showTimer = isToActSeat;

  return (
    <div
      className={`seat__avatar ${!url ? 'seat__avatar--fallback' : ''} ${showTimer ? 'has-timer' : ''}`}
      title={s.username || ''}
      style={{ position: 'relative' }}
    >
   {!showTimer && url ? (
        <img
          key={urlKey}
          src={url}
          alt={s.username || 'player'}
          draggable={false}
          onError={() => setImgError(prev => ({ ...prev, [urlKey]: true }))}
        />
      ) : !showTimer ? (
        <span className="avatar-initials">{initials}</span>
     
    ) : null}
      {showTimer && (
        <>
          {/* ВАЖНО: класс avatar-timer-ring — для поворота на «12 часов» */}
          <svg
            className="avatar-timer-ring"
            viewBox="0 0 40 40"
            aria-hidden="true"
            style={{ position: 'absolute', inset: 0 }}
          >
            <circle
              className="ring-bg"
              cx="20" cy="20" r={R}
              fill="none" stroke="rgba(255,255,255,.18)" strokeWidth="4"
            />
            <circle
              className="ring-fg"
              cx="20" cy="20" r={R}
              fill="none"
              strokeWidth="4"
              strokeLinecap="round"
              style={{ strokeDasharray: dash, stroke: ringColor }}
            />
          </svg>

          <span className="avatar-timer-num">
            {secs}
          </span>
        </>
      )}
    </div>
  );
})();







const showFaceUp = Array.isArray(seatCards) && seatCards.length === 2;

 const hasAnyCards =
  (Array.isArray(tableState?.hands?.[s.seatIndex]) && tableState.hands[s.seatIndex].length === 2) ||
  !!publicCards || !!tempCards || !!tableState?.revealAll;

const showCardsContainer =
  tableState?.phase !== 'waiting' && taken && !folded && (Number(s.stack) > 0 || hasAnyCards);










  


    return (
      
      <div key={s.seatIndex} 
      ref={(el) => { seatRefs.current[s.seatIndex] = el; }}   // 👈 вот это
      className={`seat seat--${s.seatIndex} ${taken ? 'is-taken' : 'is-free'}`}>
        {isDealer && <div className="dealer-btn">D</div>}
        {/* {isSB && <div className="blind-badge blind-badge--sb">SB</div>}
        {isBB && <div className="blind-badge blind-badge--bb">BB</div>} */}

       <div className={`seat__inner ${isToAct && taken ? 'is-turn' : ''} ${isHeroSeat ? 'is-hero' : ''} ${folded ? 'is-folded' : ''}`}>
 


 <div className="seat__cards seat__cards--dock">

  {/* ② Аватар теперь встроен слева в плашку */}
  {seatAvatarNode}

  {/* ③ Текст внутри плашки: ник и стек */}
  <div className="seat__label">
    <div className="seat__nick">{s.username || '—'}</div>
    <div className="seat__amount">${Number(s.stack).toFixed(2)}</div>
  </div>

  {/* ④ Сами карты: торчат «из-под» плашки (CSS уже делает) */}
  {showCardsContainer ? (
    showFaceUp ? (
      <>
        <Card code={seatCards?.[0]} />
        <Card code={seatCards?.[1]} />
      </>
    ) : (
      <>
        <div className="p-card p-card--back" />
        <div className="p-card p-card--back" />
      </>
    )
  ) : null}
</div>



         

          {/* Кнопка для проигравшего: показать карты на 3 сек (только на своём месте) */}
  {isHeroSeat
    && tableState?.phase === 'showdown'
    && !winnerNow
    && !visibleToTableNow
    && Array.isArray(tableState?.hands?.[s.seatIndex])
    && (
      <button
        className="p-btn p-btn--ghost"
        style={{ marginTop: 6 }}
        onClick={() => onRevealCardsForSeat(s.seatIndex)}
        type="button"
      >
        Показать на 3 сек
      </button>
    )
  }
{/* Кнопка "Сесть" показывается, если место свободно, герой ещё не сидит и не спектатор */}
{!taken && mySeatIndex === null && !spectator && (
  <button
    className="p-btn1"
    onClick={() => handleJoinSeat(s.seatIndex)}
    type="button"
  >
    Сесть
  </button>
)}

       {/* {taken && last && last.put > 0 && <div className="seat__lastbet">−${last.put}</div>} */}


{taken && last && last.put > 0 && (
  <div className="seat__lastbet">
    −${Number(last.put).toFixed(2)}
  </div>
)}


{tableState?.phase === 'showdown' && winnerNow && (
  <>
    <div className="winner-badge">WINNER</div>
    {(
      tableState?.bestHands?.[s.seatIndex]?.label ??
      tableState?.details?.[s.seatIndex]?.label
    ) && (
      <div className="seat__handlabel">
        {tableState?.bestHands?.[s.seatIndex]?.label ?? tableState?.details?.[s.seatIndex]?.label}
      </div>
    )}
  </>
)}

        {/* {tableState?.phase === 'showdown' && Array.isArray(tableState?.winners) && tableState.winners.includes(s.seatIndex) && (
  <>
    <div className="winner-badge">WINNER</div>
    {tableState?.bestHands?.[s.seatIndex]?.label && (
      <div className="seat__handlabel">{tableState.bestHands[s.seatIndex].label}</div>
    )}
  </>
)} */}

        </div>
      </div>
    );
  };
const boardCards = tableState?.board ?? [];

  return (
    <div className="poker-wrap">
      {netMsg && (
  <div className="net-banner" role="status" aria-live="polite">
    {netMsg}
  </div>
)}

      <div className="poker-topbar">
        <button className="p-btn p-btn--ghost" onClick={() => safeLeaveTable(tableId, { navigateAfter: true })}>← Лобби</button>
{mySeatIndex !== null && Number(tableState?.seats?.[mySeatIndex]?.stack || 0) === 0 && (
  <button className="p-btn p-btn--ghost" onClick={handleLeaveSeat} style={{ marginLeft: 8 }}>
    Встать
  </button>
)}

        <div className="topbar-info">
          <span>Стол #{tableId}</span>
          {/* <span>Блайнды: ${tableState?.blinds?.sb ?? 0}/{tableState?.blinds?.bb ?? 0}</span> */}
          <span>
  Блайнды: $
  {Number(tableState?.blinds?.sb ?? 0).toFixed(2)}/
  {Number(tableState?.blinds?.bb ?? 0).toFixed(2)}
</span>

          <span>Банк: ${Number(tableState?.pot || 0).toFixed(2)}</span>
          <span>Фаза: {tableState?.phase}</span>
        </div>
      </div>

 <div
  className="poker-table-canvas"
  ref={tableRef}
  data-deal-key={tableState?.__turnId || 0}
  style={{ '--chip-flight': `${CHIP_FLIGHT_MS}ms` }}   // <-- ДОБАВЬ ЭТО
>
  <TableFelt />
  <div className="boardPoker">

  {boardCards.map((c, i) => <Card key={`${i}-${c}`} code={c} big />)}
</div>
<div className="table-pot" ref={potRef}>
  <PotPile amount={Number(tableState?.pot || 0)} />
  <div className="pot-amount">
    {tableState?.phase === 'waiting' ? '$0.00' : `$${Number(tableState?.pot || 0).toFixed(2)}`}
  </div>
</div>

{tableState?.phase === 'showdown' && tableState?.info && (
  <div className="table-info">{tableState.info}</div>
  
)}
<div className={`poker-seats poker-seats--${seats.length}`}>
  {seats.map(renderSeat)}
</div>

{/* <ChipsLayer state={tableState} seatRefs={seatRefs} potRef={potRef} tableRef={tableRef} /> */}
<ChipsLayer
  state={tableState}
  seatRefs={seatRefs}
  potRef={potRef}
  tableRef={tableRef}
  winners={effectiveWinners}
  flightMs={CHIP_FLIGHT_MS}
/>


{isSittingOutNow && myStackNow > 0 && tableState?.phase !== 'waiting' && (
  <div className="entry-mode" style={{ position: 'absolute', left: 20, bottom: 20, zIndex: 30 }}>
    <div className="hint" style={{ marginBottom: 8, opacity: 0.8 }}>
      {mySeatFull?.waitForBB ? 'Вы вне раздачи: режим «Жду BB»' : 'Вы вне раздачи'}
    </div>
    <button
      className="p-btn"
      onClick={() => setEntryMode('waitBB')}
      style={{ marginRight: 8 }}
      disabled={mySeatIndex == null || myStackNow <= 0}
    >
      Ждать BB
    </button>
    <button
      className="p-btn p-btn--gold"
      onClick={() => setEntryMode('postBB')}
      disabled={mySeatIndex == null || myStackNow <= 0}
    >
      Поставить BB сейчас
    </button>
  </div>
)}


    {amToAct && !mySeatFull?.sittingOut && heroSeatIndex >= 0 && (
  <div className="stars-dock">
    <div className="stars-dock__row">
      <button className="p-btn p-btn--danger" onClick={onFold}>Fold</button>
      <button className="p-btn" onClick={onCheckCall}>
        {Number(allowed.callAmount || 0) > 0 ? `Call $${Number(allowed.callAmount).toFixed(2)}` : 'Check'}
      </button>
    </div>


{canAllInOnly && !canBetRaise && (
  <div className="stars-dock__bet">
    <button className="p-btn p-btn--gold" onClick={onAllIn}>
      All-in ${Number(allInTo).toFixed(2)}
    </button>
  </div>
)}


    {canBetRaise && (
      <div className="stars-dock__bet">
        <div className="stars-dock__quick">
          {/* <button className="p-btn" onClick={() => onConfirmBetRaise(quick1)}> */}
         <button className="p-btn" onClick={() => { playBetAndBroadcast(); onConfirmBetRaise(quick1); }}>
          Bet ${bbVal.toFixed(2)}
        </button>
        <button className="p-btn" onClick={() => { playBetAndBroadcast(); onConfirmBetRaise(quick3); }}>
          3BB
        </button>

          <button className="p-btn" onClick={() => onConfirmBetRaise(maxSlider || quickAmount)}>
            All-in
          </button>
        </div>

        <div className="stars-dock__slider">
          <input
            type="range"
            min={Math.max(minSlider, 0)}
            max={Math.max(maxSlider, Math.max(minSlider, 0))}
            step={betStep}
            value={quickAmount}
            onChange={(e) => setQuickAmount(roundToStep(Number(e.target.value), minSlider || betStep, betStep))}
          />
          <div className="stars-dock__amount">${Number(quickAmount).toFixed(2)}</div>
          <button className="p-btn p-btn--gold" onClick={() => { playBetAndBroadcast(); onConfirmBetRaise(quickAmount); }}>
            {raiseMode ? 'Raise' : 'Bet'} ${Number(quickAmount).toFixed(2)}
          </button>
        </div>
      </div>
    )}
  </div>
)}

      </div>

    </div>
  );
}
